/* =====================================================================
   KK commerce réteg (3. kör): kézbesítési idővonal, expressz-kapcsoló,
   kosár-segédek, szezonális menüpont, CRO események.
   Konfiguráció: <script id="kk-config"> (snippets/kk-config.liquid).
   Szabály: árat, díjat, határidőt itt sem írunk kézzel, minden a configból.
   ===================================================================== */
(() => {
  'use strict';
  const el = document.getElementById('kk-config');
  let cfg = {};
  try { cfg = JSON.parse(el ? el.textContent : '{}'); } catch (e) { cfg = {}; }
  window.KK = window.KK || {};
  KK.cfg = cfg;

  /* ---------- CRO események (Shopify customer events) ---------- */
  KK.track = (name, data = {}) => {
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, data); } catch (e) {}
  };

  /* ---------- Pénz ---------- */
  /* A bolt pénzformátumát követi (amount_no_decimals_with_comma_separator: 1.190 Ft), mint a Minimog és a Teeinblue. */
  const SEP = /comma_separator/.test(cfg.money_format || '') ? '.' : ' ';
  KK.money = (cents) => {
    const v = Math.round((cents || 0) / 100);
    return v.toString().replace(/\B(?=(\d{3})+(?!\d))/g, SEP) + ' Ft';
  };

  /* ---------- Dátum, munkanap (Europe/Budapest) ---------- */
  const HOL = new Set(cfg.holidays || []);
  const XTRA = new Set(cfg.extra_workdays || []);
  const iso = (d) => d.toISOString().slice(0, 10);
  const addDays = (d, n) => new Date(d.getTime() + n * 864e5);
  const isWork = (d) => { const k = iso(d); if (XTRA.has(k)) return true; const w = d.getUTCDay(); return w >= 1 && w <= 5 && !HOL.has(k); };
  const nextWork = (d) => { let x = addDays(d, 1); while (!isWork(x)) x = addDays(x, 1); return x; };
  const addWork = (d, n) => { let x = d; for (let i = 0; i < n; i++) x = nextWork(x); return x; };
  const bpNow = () => {
    const f = new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Budapest', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' });
    const p = Object.fromEntries(f.formatToParts(new Date()).map((x) => [x.type, x.value]));
    return { day: new Date(Date.UTC(+p.year, +p.month - 1, +p.day)), min: (+p.hour % 24) * 60 + +p.minute };
  };
  const hm = (s) => { const [h, m] = String(s || '14:00').split(':').map(Number); return h * 60 + (m || 0); };
  const MON = ['jan.', 'febr.', 'márc.', 'ápr.', 'máj.', 'jún.', 'júl.', 'aug.', 'szept.', 'okt.', 'nov.', 'dec.'];
  const DOW = ['vasárnap', 'hétfő', 'kedd', 'szerda', 'csütörtök', 'péntek', 'szombat'];
  const fd = (d, wd) => `${MON[d.getUTCMonth()]} ${d.getUTCDate()}.${wd ? ', ' + DOW[d.getUTCDay()] : ''}`;
  const fr = (a, b) => {
    if (iso(a) === iso(b)) return fd(a);
    if (a.getUTCMonth() === b.getUTCMonth()) return `${MON[a.getUTCMonth()]} ${a.getUTCDate()}-${b.getUTCDate()}.`;
    return `${fd(a)} - ${fd(b)}`;
  };
  KK.date = { isWork, nextWork, addWork, bpNow, fd, fr, iso };

  /* ---------- Szabadság (J-100): a szabadság napjain nem gyártunk; a futár munkanapjai nem változnak ---------- */
  const VAC = cfg.vacation && cfg.vacation.start && cfg.vacation.end ? cfg.vacation : null;
  const pd = (k) => new Date(k + 'T00:00:00Z');
  const inVac = (k) => !!VAC && k >= VAC.start && k <= VAC.end;
  const isProd = (d) => isWork(d) && !inVac(iso(d));
  const nextProd = (d) => { let x = addDays(d, 1); while (!isProd(x)) x = addDays(x, 1); return x; };
  const addProd = (d, n) => { let x = d; for (let i = 0; i < n; i++) x = nextProd(x); return x; };
  const DOW2 = (d) => ['vasárnap', 'hétfő', 'kedd', 'szerda', 'csütörtök', 'péntek', 'szombat'][d.getUTCDay()];
  const fdw = (d) => `${fd(d)} (${DOW2(d)})`;
  /* Birtokos rag a napszámhoz: 3-ától, 2-áig, 22-éig, 21-jétől */
  const poss = (n) => { const l = n % 10; if (l === 0) return n === 10 ? 'é' : 'á'; return ({ 1: 'jé', 2: 'á', 3: 'á', 4: 'é', 5: 'é', 6: 'á', 7: 'é', 8: 'á', 9: 'é' })[l]; };
  const fdx = (d, k, wd) => { const p = poss(d.getUTCDate()); const sx = k === 'tol' ? p + (p.endsWith('á') ? 'tól' : 'től') : p + 'ig'; return `${MON[d.getUTCMonth()]} ${d.getUTCDate()}-${sx}${wd ? ' (' + DOW2(d) + ')' : ''}`; };
  const vacLastOrderMs = () => (VAC && VAC.last_order ? Date.parse(VAC.last_order) : NaN);
  KK.vac = {
    cfg: VAC,
    /* 'none' | 'notice' (előzetes) | 'on' (szabadság alatt) */
    phase() {
      if (!VAC) return 'none';
      const t = iso(bpNow().day);
      if (t > VAC.end) return 'none';
      if (t >= VAC.start) return 'on';
      const from = VAC.notice_from || iso(addDays(pd(VAC.start), -7));
      return t >= from ? 'notice' : 'none';
    },
    resume() { return VAC ? nextProd(pd(VAC.end)) : null; },
    lastBefore() { if (!VAC) return null; let x = addDays(pd(VAC.start), -1); while (!isWork(x)) x = addDays(x, -1); return x; },
    /* Még a szabadság előtt feladjuk? (csak ha meg van adva az utolsó rendelés időpontja) */
    preVacOk() { const lo = vacLastOrderMs(); return !!VAC && !isNaN(lo) && Date.now() <= lo && iso(bpNow().day) < VAC.start; },
    /* A határidő után, de a szabadság vége előtt leadott fizikai rendelés a szabadság után indul. */
    afterLastOrder() { const lo = vacLastOrderMs(); return !!VAC && !isNaN(lo) && Date.now() > lo && iso(bpNow().day) <= VAC.end; },
    expressBlocked() { const ph = KK.vac.phase(); return ph === 'on' || (ph === 'notice' && KK.vac.afterLastOrder()); },
    lastOrderTxt() {
      const lo = vacLastOrderMs(); if (isNaN(lo)) return '';
      const f = new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Budapest', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' });
      const q = Object.fromEntries(f.formatToParts(new Date(lo)).map((x) => [x.type, x.value]));
      return `${fdw(new Date(Date.UTC(+q.year, +q.month - 1, +q.day)))} ${q.hour}:${q.minute}`;
    }
  };

  /* Gyártás kezdőnapja: munkanapon a határidő előtt ma, különben a következő munkanap. */
  const startDay = (cutoffMin, prod) => {
    const ok = prod === false ? isWork : isProd, nx = prod === false ? nextWork : nextProd;
    const n = bpNow(); const today = n.day;
    if (prod !== false && KK.vac.afterLastOrder()) return { start: KK.vac.resume(), beforeCutoff: false, today };
    return { start: ok(today) && n.min < cutoffMin ? today : nx(today), beforeCutoff: ok(today) && n.min < cutoffMin, today };
  };

  /* Termékcsoport a terméktípusból (a kk-group.liquid tükre; a kosár JSON-ban nincs metamező). */
  KK.groupOf = (t) => {
    t = t || '';
    if (t.includes('Rózsabox')) return 'Rózsabox';
    if (/hűtőmágnes/i.test(t)) return 'Hűtőmágnes';
    if (t.includes('3D')) return '3D nyomtatott';
    if (t === 'Fa' || t.includes('Fa,') || t === 'Kulcstartó' || t === 'Mérőszalag') return 'Gravírozott és lézervágott';
    if (t === 'Bögre') return 'Bögre';
    if (t.includes('Plexi')) return 'UV plexi';
    if (/gyertya/i.test(t)) return 'Gyertya';
    if (t.includes('gömb')) return 'Egyéb ajándéktárgy';
    if (t === 'Kiegészítők') return 'Kiegészítő';
    return 'Falikép';
  };
  /* Expressz termékcsoportonként (kk_termekcsoport.expressz_elerheto; alapból csak Falikép). */
  KK.expressOk = (group) => { const g = (cfg.groups || {})[group]; return g ? g.express === true : group === 'Falikép'; };

  KK.expressDated = () => { const sw = (cfg.express && cfg.express.mode_switch) || '2027-01-04'; return iso(bpNow().day) >= sw; };

  /** Becslés. opts: { group, digital, giftwrap, express } */
  KK.estimate = (opts) => {
    const g = (cfg.groups || {})[opts.group] || { min: 1, max: 2, wrap: 1 };
    // A-33: a módokat a sorrend mező szerint rendezzük; a kézbesítési tartomány a leggyorsabb módtól a leglassabbig tart.
    const ships = (cfg.shipping || []).filter((s) => s && s.name).slice().sort((a, b) => (Number(a.order) || 99) - (Number(b.order) || 99));
    const ship = ships.length
      ? { name: ships[0].name, note: ships[0].note, min: Math.min(...ships.map((s) => Number(s.min) || 1)), max: Math.max(...ships.map((s) => Number(s.max) || 2)) }
      : { min: 1, max: 2, note: '' };
    if (opts.digital) {
      const dProd = !(VAC && VAC.digital !== false);
      const s = startDay(hm(cfg.cutoff), dProd ? undefined : false);
      const ready = (dProd ? addProd : addWork)(s.start, Math.max(0, (cfg.digital_days || 1) - 1));
      return { digital: true, beforeCutoff: s.beforeCutoff, readyA: ready, readyB: ready, delA: ready, delB: ready };
    }
    let pmin = g.min, pmax = g.max, cut = hm(cfg.cutoff);
    if (opts.express && KK.expressDated()) { pmin = pmax = (cfg.express && cfg.express.days) || 1; cut = hm(cfg.express && cfg.express.cutoff); }
    if (opts.giftwrap) { pmin += g.wrap || 1; pmax += g.wrap || 1; }
    const s = startDay(cut);
    let readyA = addProd(s.start, pmin - 1), readyB = addProd(s.start, pmax - 1);
    // J-100: a megadott utolsó rendelési időpontig leadott rendelést még a szabadság előtt feladjuk.
    if (KK.vac.preVacOk()) { const lb = KK.vac.lastBefore(); if (readyA > lb) readyA = lb; if (readyB > lb) readyB = lb; }
    return { beforeCutoff: s.beforeCutoff, cutoff: opts.express && KK.expressDated() ? cfg.express.cutoff : cfg.cutoff, readyA, readyB, delA: addWork(readyA, ship.min), delB: addWork(readyB, ship.max), shipNote: ship.note, shipName: ship.name };
  };

  /* ---------- Első valódi interakció (ezzel áll le a böngésző LCP-mérése) ---------- */
  KK.onFirstInput = (fn) => {
    let done = false;
    const evs = ['pointerdown', 'keydown', 'touchstart', 'wheel'];
    const go = () => { if (done) return; done = true; evs.forEach((e) => removeEventListener(e, go, true)); fn(); };
    evs.forEach((e) => addEventListener(e, go, { capture: true, passive: true }));
  };

  /* ---------- Kosár segédek ---------- */
  let cartCache = null;
  KK.cart = async (fresh) => {
    if (!fresh && cartCache) return cartCache;
    const r = await fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart.js', { headers: { Accept: 'application/json' } });
    const t = await r.text();
    try { cartCache = JSON.parse(t); } catch (e) {
      // Hibás vagy nem JSON válasz (pl. terhelés, átirányítás): nem dobunk hibát, a korábbi kosáradat marad.
      console.warn('[KK] cart.js nem JSON:', r.status, t.slice(0, 60));
      return cartCache || { items: [], item_count: 0, total_price: 0 };
    }
    return cartCache;
  };
  KK.cartHas = (cart, vid) => (cart.items || []).some((i) => i.variant_id === vid);
  KK.refreshCart = () => {
    cartCache = null;
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    document.dispatchEvent(new CustomEvent('kk:cart-changed'));
  };
  KK.add = async (id, qty = 1, properties) => {
    const r = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id, quantity: qty, properties: properties || {} }] }) });
    if (!r.ok) throw new Error((await r.json()).description || 'cart add error');
    KK.refreshCart(); return r.json();
  };
  KK.removeVariant = async (vid) => {
    const cart = await KK.cart(true);
    const line = (cart.items || []).find((i) => i.variant_id === vid);
    if (!line) return;
    await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: line.key, quantity: 0 }) });
    KK.refreshCart();
  };

  /* ---------- Kézbesítési idővonal ---------- */
  function initDelivery(box) {
    const group = box.dataset.group || 'Falikép';
    const digitalIds = new Set((box.dataset.digital || '').split(',').filter(Boolean).map(Number));
    const head = box.querySelector('[data-kk-dlv-head]');
    const steps = box.querySelector('[data-kk-dlv-steps]');
    const d1 = box.querySelector('[data-kk-d1]'), d2 = box.querySelector('[data-kk-d2]'), d2l = box.querySelector('[data-kk-d2-lbl]');
    const note = box.querySelector('[data-kk-dlv-note]');
    const sw = box.querySelector('[data-kk-express]');
    const swInput = sw && sw.querySelector('input');
    const warn = box.querySelector('[data-kk-express-warn]');
    const form = box.closest('form') || document.querySelector('form[action*="/cart/add"]');
    const state = { digital: false, giftwrap: false, express: false };

    const currentVariant = () => {
      const inp = (form && form.querySelector('[name="id"]')) || document.querySelector('form[action*="/cart/add"] [name="id"]');
      return inp ? Number(inp.value) : 0;
    };
    const render = (flash) => {
      // A-25: a digitális változat bármelyik opcióban lehet (nem csak az elsőben).
      // A Teeinblue terméktípus-választója (Available Products) nem Shopify-opció: a kijelölt elem feliratát is nézzük.
      // A Teeinblue a kijelölést .tee-radio.active osztállyal jelzi (2026-10-19 javítva, korábban csak :checked).
      const ap = document.querySelector('.tee-available-products .tee-radio.active input') || document.querySelector('.tee-available-products input:checked');
      const apTxt = ap ? ((ap.closest('.tee-radio') || ap.parentElement || {}).textContent || '') : '';
      state.digital = digitalIds.has(currentVariant()) || /digit/i.test(apTxt) || KK.selectedOptions().some((o) => /digit|png\/pdf|png fájl/i.test(o || ''));
      const e = KK.estimate({ group, digital: state.digital, giftwrap: state.giftwrap, express: state.express });
      const when = e.beforeCutoff ? `Ma <span class="kk-dlv__cutoff">${e.cutoff}</span>-ig rendelve` : 'Most rendelve';
      const vph = KK.vac.phase();
      if (e.digital && vph === 'on' && VAC.digital === false) {
        head.innerHTML = `Szabadság miatt a digitális fájlt <strong>${fdx(e.readyA, 'ig', true)}</strong> küldjük e-mailben. Postán nem küldünk semmit.`;
        d1.textContent = fd(e.readyA); d2l.textContent = 'E-mailben'; d2.textContent = fd(e.readyA);
        note.textContent = KK.vac.note();
      } else if (e.digital && vph === 'on') {
        head.innerHTML = 'Szabadság alatt is: a digitális fájlt <strong>24 órán belül</strong> e-mailben küldjük. Postán nem küldünk semmit.';
        d1.textContent = '24 órán belül'; d2l.textContent = 'E-mailben'; d2.textContent = 'Automatikusan';
        note.textContent = '';
      } else if (e.digital) {
        // J-65 a): a digitális fájl automatikusan, pár órán belül megy ki (Csongor, 2026-10-19).
        head.innerHTML = 'A digitális fájlt <strong>automatikusan, pár órán belül</strong> e-mailben küldjük. Postán nem küldünk semmit.';
        d1.textContent = 'Pár órán belül'; d2l.textContent = 'E-mailben'; d2.textContent = 'Automatikusan';
        note.textContent = '';
      } else {
        const rng = iso(e.delA) === iso(e.delB) ? `<strong>${fd(e.delA, true)}</strong>` : `<strong>${fr(e.delA, e.delB)}</strong> között`;
        head.innerHTML = `${when} várhatóan ${rng} nálad.`;
        d1.textContent = fr(e.readyA, e.readyB); d2l.textContent = 'Nálad'; d2.textContent = fr(e.delA, e.delB);
        const parts = [];
        if (vph !== 'none') parts.push(KK.vac.note());
        if (state.giftwrap) parts.push('A kézzel készített díszcsomagolás +1 munkanap.');
        if (e.shipNote) parts.push(e.shipNote);
        note.textContent = parts.join(' ');
      }
      steps.hidden = false;
      box.style.setProperty('--kk-dlv-progress', '33%');
      if (flash) { box.classList.remove('is-recalc'); void box.offsetWidth; box.classList.add('is-recalc'); }
    };

    const renderExpress = () => {
      if (!sw || !cfg.express || !cfg.express.variant_id) return;
      sw.hidden = !!state.digital || !KK.expressOk(group) || KK.vac.expressBlocked();
      const dated = KK.expressDated();
      sw.querySelector('[data-kk-express-sub]').textContent = dated
        ? `${cfg.express.cutoff}-ig rendelve ${cfg.express.days} munkanap alatt elkészítjük, MPL-lel küldjük`
        : 'Sorban elsőként készítjük el, MPL-lel küldjük';
      sw.querySelector('[data-kk-express-price]').textContent = '+' + KK.money(cfg.express.price);
      const blocked = state.giftwrap && !state.express;
      const soldOut = !cfg.express.available && !state.express;
      swInput.checked = state.express;
      swInput.disabled = blocked || soldOut;
      sw.classList.toggle('is-blocked', blocked || soldOut);
      warn.textContent = blocked
        ? 'A díszcsomagolás kézi munka, ezért expressz rendeléssel nem kérhető. Ha sietsz, vedd ki a díszcsomagolást a kosárból.'
        : soldOut ? 'Mára betelt az expressz keret. Holnap újra választható.' : '';
    };

    const syncCart = async (fresh) => {
      try {
        const cart = await KK.cart(fresh);
        state.giftwrap = (cfg.express.blocked_by || []).some((v) => KK.cartHas(cart, v));
        state.express = KK.cartHas(cart, cfg.express.variant_id);
      } catch (e) {}
      renderExpress(); render(false);
    };

    if (swInput) swInput.addEventListener('change', async () => {
      sw.setAttribute('aria-busy', 'true');
      try {
        if (swInput.checked) { await KK.add(cfg.express.variant_id, 1, {}); state.express = true; KK.track('kk_express_toggle', { on: true, group }); }
        else { await KK.removeVariant(cfg.express.variant_id); state.express = false; KK.track('kk_express_toggle', { on: false, group }); }
      } catch (e) { swInput.checked = !swInput.checked; }
      sw.removeAttribute('aria-busy');
      renderExpress(); render(true);
    });

    if (form) form.addEventListener('change', (ev) => { if (ev.target && (ev.target.name === 'id' || ev.target.closest('variant-picker, .m-product-option, [data-option-index]'))) setTimeout(() => { render(true); renderExpress(); }, 60); });
    onVariant(() => { render(true); renderExpress(); });
    document.addEventListener('click', (ev) => { if (ev.target && ev.target.closest && ev.target.closest('.tee-available-products')) setTimeout(() => { render(true); renderExpress(); }, 400); }, true);
    document.addEventListener('kk:cart-changed', () => syncCart(true));
    render(false); syncCart(false);
  }


  /* ---------- Kiválasztott opciók (Teeinblue vagy Minimog választó) ----------
     A Teeinblue saját választót rajzol (.tee-variants), a Minimogé rejtett.
     A Teeinblue-csoportokat értékegyezés alapján rendeljük a Shopify opciókhoz. */
  let VARS = null;
  KK.variants = () => {
    if (VARS) return VARS;
    const el = document.querySelector('script[data-kk-variants]');
    try { VARS = el ? JSON.parse(el.textContent) : []; } catch (e) { VARS = []; }
    return VARS;
  };
  KK.optionNames = () => { const el = document.querySelector('script[data-kk-variants]'); return el && el.dataset.names ? el.dataset.names.split('|') : []; };
  const teeGroups = () => {
    const vars = KK.variants(); if (!vars.length) return [];
    const n = vars[0].o.length;
    return [...document.querySelectorAll('.tee-variants .tee-option')].filter((g) => g.offsetParent !== null).map((g) => {
      const radios = [...g.querySelectorAll('input[type="radio"]')];
      const vals = radios.map((r) => r.value);
      let idx = -1;
      for (let i = 0; i < n && idx < 0; i++) { const set = new Set(vars.map((v) => v.o[i])); if (vals.length && vals.every((x) => set.has(x))) idx = i; }
      return { el: g, idx, radios };
    }).filter((g) => g.idx >= 0);
  };
  KK.selectedOptions = () => {
    const vars = KK.variants(); const n = vars.length ? vars[0].o.length : 0;
    const out = new Array(n).fill(null);
    teeGroups().forEach((g) => { const c = g.radios.find((r) => r.checked) || (g.el.querySelector('.tee-radio.active input')); if (c) out[g.idx] = c.value; });
    const picker = [...document.querySelectorAll('variant-picker')][0];
    if (picker) [...picker.querySelectorAll('[data-option-name]')].forEach((g, i) => { if (out[i] == null) { const c = g.querySelector('input:checked'); const sl = g.querySelector('select'); out[i] = c ? c.value : sl ? sl.value : g.dataset.selectedValue; } });
    return out;
  };
  const onVariant = (fn) => {
    let t = 0;
    const fire = () => { clearTimeout(t); t = setTimeout(() => fn(KK.selectedOptions()), 60); };
    document.addEventListener('variant:changed', fire);
    document.addEventListener('change', (e) => { if (e.target && e.target.closest && e.target.closest('.tee-variants, variant-picker')) fire(); }, true);
    document.addEventListener('click', (e) => { if (e.target && e.target.closest && e.target.closest('.tee-variants .tee-radio')) fire(); }, true);
  };
  KK.onVariant = onVariant;

  /* ---------- Keret és anyag: a kiválasztott keretszín (R-39) ---------- */
  function initFrames(box) {
    const cards = [...box.querySelectorAll('[data-kk-frame]')];
    if (!box.classList.contains('kk-frames-inline')) {
      if (!document.querySelector('script[data-kk-variants]')) return;
      onVariant((o) => cards.forEach((c) => c.classList.toggle('is-selected', c.dataset.kkFrame === o[1])));
      return;
    }
    const none = box.querySelector('[data-kk-frames-none]');
    const all = box.querySelector('[data-kk-frames-all]');
    let showAll = false;
    const apply = (val) => {
      const isFrame = !!val && cards.some((c) => c.dataset.kkFrame === val);
      cards.forEach((c) => {
        const sel = isFrame && c.dataset.kkFrame === val;
        c.classList.toggle('is-selected', sel);
        c.hidden = isFrame && !sel && !showAll;
      });
      if (none) none.hidden = isFrame;
      if (all) all.hidden = !isFrame || showAll;
      box.dataset.selected = val || '';
    };
    if (all) all.addEventListener('click', () => { showAll = true; apply(box.dataset.selected); });
    onVariant((o) => { showAll = false; apply(o[1]); });
    setTimeout(() => apply(KK.selectedOptions()[1] || box.dataset.selected), 800);
  }

  /* ---------- Szállítási módok táblázata a configból (R-48, R-60) ---------- */
  function initShip(box) {
    const rows = (cfg.shipping || []).filter((s) => s && s.name);
    if (!rows.length) return;
    const nap = (s) => (s.min === s.max ? `${s.min}` : `${s.min}-${s.max}`) + ' munkanap';
    box.innerHTML = '<table class="kk-ship__table"><thead><tr><th scope="col">Mód</th><th scope="col">Díj</th><th scope="col">Úton</th></tr></thead><tbody>' +
      rows.map((s) => `<tr><th scope="row">${s.name}</th><td>${KK.money(s.price)}${s.cod ? `<small>utánvét +${KK.money(s.cod)}</small>` : ''}</td><td>${nap(s)}</td></tr>`).join('') +
      '</tbody></table>' +
      `<p class="kk-ship__how">Az elkészítés ideje erre jön rá. A termék gyártási idejével együtt számolt várható dátumot a Kosárba gomb alatt látod.</p>` +
      [...new Set(rows.map((s) => s.note).filter(Boolean))].map((n) => `<p class="kk-ship__note">${n}</p>`).join('');
  }

  /* ---------- Ár a méretgombokon (11.5/5, R-27) ----------
     A méret opciónál minden gombra a többi kiválasztott opcióval érvényes variáns ára kerül. */
  function initSizePrices() {
    const vars = KK.variants(); if (!vars.length) return;
    const names = KK.optionNames();
    const sizeIdx = names.findIndex((x) => /m[ée]ret/i.test(x));
    if (sizeIdx < 0) return;
    const paint = () => {
      const sel = KK.selectedOptions();
      const priceFor = (val) => { const v = vars.find((x) => x.o[sizeIdx] === val && x.o.every((o, i) => i === sizeIdx || sel[i] == null || o === sel[i])); return v ? v.p : null; };
      const targets = [];
      teeGroups().filter((g) => g.idx === sizeIdx).forEach((g) => g.radios.forEach((r) => { const lab = g.el.querySelector(`label[for="${CSS.escape(r.id)}"]`) || r.parentElement.querySelector('label'); if (lab) targets.push([lab, r.value]); }));
      document.querySelectorAll('variant-picker').forEach((pk) => { const g = pk.querySelectorAll('[data-option-name]')[sizeIdx]; if (g) g.querySelectorAll('[data-value]').forEach((n) => { const lab = n.querySelector('label'); if (lab) targets.push([lab, n.dataset.value]); }); });
      const prices = new Set(targets.map(([, v]) => priceFor(v)).filter((p) => p != null));
      targets.forEach(([lab, v]) => {
        let tag = lab.querySelector('.kk-opt-price'); const p = priceFor(v);
        if (p == null || prices.size < 2) { if (tag) tag.remove(); return; }
        if (!tag) { tag = document.createElement('span'); tag.className = 'kk-opt-price'; lab.appendChild(tag); lab.classList.add('kk-has-price'); }
        tag.textContent = KK.money(p);
      });
    };
    paint(); setTimeout(paint, 1200); setTimeout(paint, 3000);
    onVariant(paint);
  }


  /* ---------- Hiányzó mezők összesítése a kosár gomb felett (11.5/10, R-32) ----------
     A Teeinblue maga jelöli a hibás mezőket (.tee-field--invalid) és odagörget;
     mi a gomb fölé írjuk, hány és milyen mező hiányzik, és mérjük (kk_atc_missing). */
  function initMissing() {
    const visible = (e) => e && e.offsetParent !== null;
    const scan = () => {
      const fields = [...document.querySelectorAll('.tee-field--invalid')].filter(visible);
      const confirm = [...document.querySelectorAll('.tee-error')].filter(visible).filter((e) => /megerősítő|négyzet/i.test(e.innerText || ''));
      const photos = fields.filter((f) => f.classList.contains('tee-field--photo')).length;
      const head = (f) => ((f.querySelector('.tee-field__heading > span') || {}).textContent || '').trim();
      const names = fields.filter((f) => f.classList.contains('tee-field--text') || f.querySelector('textarea')).map(head).filter(Boolean);
      const questions = fields.length - photos - names.length;
      return { fields, confirm, photos, names, questions, n: fields.length + (confirm.length ? 1 : 0) };
    };
    let box = null;
    const ensureBox = (btn) => {
      const host = btn.closest('.tee-form-actions, .tee-form-action') || btn.parentElement;
      if (!box) {
        box = document.createElement('div');
        box.className = 'kk-missing'; box.setAttribute('role', 'alert');
        box.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M12 7v6M12 16.5v.5"/></svg><span data-kk-missing-txt></span><button type="button" data-kk-missing-go>Mutasd</button>';
        box.querySelector('[data-kk-missing-go]').addEventListener('click', () => { const s = scan(); const t = s.fields[0] || s.confirm[0]; if (t) { t.scrollIntoView({ behavior: 'smooth', block: 'center' }); const i = t.querySelector('input, textarea, button'); if (i) setTimeout(() => i.focus({ preventScroll: true }), 400); } });
      }
      if (box.parentElement !== host.parentElement) host.parentElement.insertBefore(box, host);
      return box;
    };
    const render = (btn, track) => {
      const s = scan();
      if (!s.n) { if (box) box.classList.remove('is-visible'); return; }
      const parts = [];
      if (s.names.length) parts.push(s.names.slice(0, 2).join(', ') + (s.names.length > 2 ? ` és még ${s.names.length - 2} szöveg` : ''));
      if (s.photos) parts.push(`${s.photos} fotó`);
      if (s.questions > 0) parts.push(`${s.questions} kérdés`);
      if (s.confirm.length) parts.push('a megerősítő jelölő');
      const b = ensureBox(btn);
      b.querySelector('[data-kk-missing-txt]').textContent = `Még ${s.n} dolog hiányzik: ${parts.join(', ')}.`;
      b.classList.remove('is-visible'); void b.offsetWidth; b.classList.add('is-visible');
      if (track) KK.track('kk_atc_missing', { count: s.n, photos: s.photos, questions: s.questions, confirm: !!s.confirm.length });
    };
    document.addEventListener('click', (e) => {
      const btn = e.target.closest && e.target.closest('.tee-btn--atc');
      if (!btn) return;
      setTimeout(() => render(btn, true), 400);
    }, true);
    const recheck = () => { if (box && box.classList.contains('is-visible')) { const btn = document.querySelector('.tee-btn--atc'); if (btn) setTimeout(() => render(btn, false), 300); } };
    document.addEventListener('change', recheck, true);
    document.addEventListener('input', recheck, true);
  }


  /* ---------- Előnézeti kapcsolók tesztre: ?kk_preview=bf,upsell (a munkamenetre megmarad) ----------
     A-10: csak nem publikált téma előnézetében vagy a szerkesztőben működik; az élő témán
     a paraméter hatástalan, és a munkamenetben maradt kulcsot is töröljük. */
  const PREVIEW = (() => {
    try {
      const S = window.Shopify || {};
      const isPreview = !!S.designMode || !!(S.theme && S.theme.role && S.theme.role !== 'main');
      if (!isPreview) { sessionStorage.removeItem('kk_preview'); return new Set(); }
      const q = new URLSearchParams(location.search).get('kk_preview');
      if (q != null) sessionStorage.setItem('kk_preview', q);
      return new Set((sessionStorage.getItem('kk_preview') || '').split(',').filter(Boolean));
    } catch (e) { return new Set(); }
  })();
  KK.preview = PREVIEW;

  /* ---------- Kosár-kiegészítések (11.6, P-2, P-5, P-8, P-9, P-10, D-06) ----------
     Kosároldalon és a drawerben is: a Minimog lábléce elé illesztjük (vanilla fájl
     módosítása nélkül), és a lábléc újrarajzolása után visszatesszük. */
  function initCartExtras() {
    const nonMain = new Set((cfg.variants && cfg.variants.non_main_products) || []);
    const photoTypes = cfg.photo_types || [];
    const up = Object.assign({}, cfg.cart_upsell || {});
    if (PREVIEW.has('upsell')) { up.giftwrap = true; up.digital = true; up.magnet4 = true; up.express = true; up.giftflag = true; }
    const bf = cfg.promo_bf || {};
    const now = Date.now();
    const bfOn = PREVIEW.has('bf') || (bf.start && bf.end && now >= Date.parse(bf.start) && now <= Date.parse(bf.end));
    const nodes = new Map();
    const ic = {
      gift: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><rect x="3" y="9" width="18" height="12" rx="1.5"/><path d="M3 13h18M12 9v12M12 9c-2-4-6-4-6-1.5S10 9 12 9zm0 0c2-4 6-4 6-1.5S14 9 12 9z"/></svg>',
      truck: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="M3 7h11v9H3zM14 10h4l3 3v3h-7"/><circle cx="7" cy="17.5" r="1.6"/><circle cx="17.5" cy="17.5" r="1.6"/></svg>',
    };

    const build = () => {
      const el = document.createElement('div');
      el.className = 'kk-cartx';
      el.setAttribute('data-kk-cartx', '');
      el.dataset.kkUid = String(nodes.size + 1);
      el.innerHTML = `
        <label class="kk-digi-ack" data-kk-digi hidden><input type="checkbox" data-kk-digi-input><span><strong>Digitális fájl van a kosaradban.</strong> ${DIGI_ACK_TXT}</span></label>
        <div class="kk-progress" data-kk-bf hidden><p class="kk-progress__msg" data-kk-bf-txt></p><div class="kk-progress__bar"><span data-kk-bf-bar></span></div></div>
        <div class="kk-plusz" data-kk-plusz hidden></div>
        <div class="kk-upsell" data-kk-upsell hidden><p class="kk-upsell__title">Tedd teljessé</p><div class="kk-upsell__list" data-kk-upsell-list></div></div>
        <div data-kk-cx-express></div>
        ${up.giftflag ? '<label class="kk-check"><input type="checkbox" data-kk-giftflag><span><strong>Ajándékba küldöm</strong></span></label>' : ''}
        <p class="kk-cartx__ship">${ic.truck}<span data-kk-cx-ship></span></p>`;
      el._kkShip = el.querySelector('.kk-cartx__ship');
      return el;
    };

    const upsellItem = (key, title, sub, priceLabel, img, extra) => `
      <div class="kk-upsell__item" data-kk-up="${key}">
        ${img ? `<img src="${img}" alt="" width="56" height="56" loading="lazy">` : '<span class="kk-upsell__img"></span>'}
        <div><p class="kk-upsell__name">${title}</p><p class="kk-upsell__desc">${sub}</p><p class="kk-upsell__price">${priceLabel}</p></div>
        <button type="button" class="kk-upsell__add" data-kk-up-add>Hozzáadom</button>
        ${extra || ''}
      </div>`;

    const MP = cfg.mosoly_plusz || {};
    const mpOn = !!MP.on || PREVIEW.has('plusz');
    const mpVids = Object.values(MP.variants || {}).map(Number);
    const mpFee = (base) => { const f = Math.round((base * (MP.pct || 9)) / 100 / 10000) * 10000 - 1000; return Math.min(MP.max || 199000, Math.max(MP.min || 79000, f)); };
    const mpVidFor = (fee) => { const m = MP.variants || {}; const keys = Object.keys(m).map(Number).sort((a, b) => a - b); const k = keys.find((x) => x >= fee) || keys[keys.length - 1]; return k != null ? Number(m[k]) : null; };
    let mpBusy = false;
    const mpSync = async (updates) => {
      if (mpBusy) return; mpBusy = true;
      try { await fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ updates }) }); } catch (e) {}
      mpBusy = false; KK.refreshCart();
    };
    const renderPlusz = async (root, cart, physical) => {
      const box = root.querySelector('[data-kk-plusz]'); if (!box) return;
      const lines = (cart.items || []).filter((i) => mpVids.includes(i.variant_id));
      const base = physical.reduce((a, i) => a + (i.final_line_price != null ? i.final_line_price : i.line_price), 0);
      // kikapcsolva, vagy nincs fizikai termék: ne maradjon a kosárban
      if (!mpOn || !physical.length || !mpVids.length) {
        box.hidden = true; box.innerHTML = '';
        if (lines.length && !mpBusy) { const u = {}; lines.forEach((l) => { u[l.variant_id] = 0; }); await mpSync(u); }
        return;
      }
      const fee = mpFee(base), vid = mpVidFor(fee), inCart = lines.length > 0;
      if (inCart && !mpBusy && (lines.length > 1 || lines[0].variant_id !== vid || lines[0].quantity !== 1)) {
        const u = {}; lines.forEach((l) => { u[l.variant_id] = 0; }); u[vid] = 1; await mpSync(u); return;
      }
      const price = inCart ? lines[0].final_line_price : fee;
      box.hidden = false;
      box.innerHTML = `<label class="kk-plusz__row"><input type="checkbox" data-kk-plusz-input ${inCart ? 'checked' : ''}>
        <span class="kk-plusz__body"><span class="kk-plusz__title">Mosoly Plusz <span class="kk-plusz__price">+${KK.money(price)}</span></span>
        <span class="kk-plusz__sub">${MP.days || 45} napos garancia, és ha elírtál valamit vagy gyenge fotót töltöttél fel, egyszer ingyen újra elkészítjük, visszaküldés nélkül. Erősebb doboz dupla buborékfóliával, soron kívüli ügyintézés.</span>
        <a class="kk-plusz__more" href="${MP.url || '/pages/mosoly-plusz'}" target="_blank" rel="noopener">Részletek</a></span></label>`;
    };

    const render = async (root) => {
      let cart;
      try { cart = await KK.cart(true); } catch (e) { return; }
      const items = cart.items || [];
      const main = items.filter((i) => !nonMain.has(i.product_id) && !i.gift_card);
      const mainQty = main.reduce((a, i) => a + i.quantity, 0);
      const physical = main.filter((i) => !/digit/i.test((i.options_with_values && i.options_with_values[0] && i.options_with_values[0].value) || ''));
      const photo = physical.filter((i) => photoTypes.some((t) => (i.product_type || '').includes(t)));
      // A hűtőmágnes-ajánlat csak ott, ahol valóban vannak feltöltött fotók (csillagtérképnél nincs).
      const withPhotos = physical.filter((i) => KK.hasPhotos(i.properties));
      const has = (vid) => KK.cartHas(cart, vid);
      root.hidden = !items.length;

      // BF V3 folyamatjelző: 2+ fő termék
      const bfBox = root.querySelector('[data-kk-bf]');
      if (bfOn && mainQty > 0) {
        const done = mainQty >= (bf.min_main_items || 2);
        bfBox.hidden = false; bfBox.dataset.state = done ? 'done' : 'partial';
        root.querySelector('[data-kk-bf-txt]').innerHTML = done ? '<strong>Kész!</strong> A díszcsomagolás és a szállítás ajándék.' : `Még <strong>${(bf.min_main_items || 2) - mainQty} termék</strong>, és a csomagolás és a szállítás ajándék.`;
        root.querySelector('[data-kk-bf-bar]').style.setProperty('--p', Math.min(100, (mainQty / (bf.min_main_items || 2)) * 100) + '%');
      } else bfBox.hidden = true;

      // J-94: Mosoly Plusz (fizetős garancia). A díj a fizikai termékek értékéből számolt sáv; a kosár változásakor a változatot átváltjuk.
      await renderPlusz(root, cart, physical);

      // Upsell: legfeljebb 3
      const list = [];
      const v = cfg.variants || {}, pr = cfg.prices || {}, im = cfg.images || {};
      const expressIn = has(v.express);
      const wrapFree = bfOn && mainQty >= (bf.min_main_items || 2);
      if (up.giftwrap && physical.length) {
        if (has(v.giftwrap)) list.push(`<div class="kk-upsell__item is-added" data-kk-up="giftwrap">${im.giftwrap ? `<img src="${im.giftwrap}" alt="" width="56" height="56" loading="lazy">` : '<span class="kk-upsell__img"></span>'}<div><p class="kk-upsell__name">Díszcsomagolás a kosárban</p><p class="kk-upsell__desc">Kézzel csomagoljuk, +1 munkanap.</p></div></div>`);
        else if (!expressIn) list.push(upsellItem('giftwrap', 'Díszcsomagolás', 'Kézzel csomagoljuk, készen áll az átadásra. +1 munkanap.', wrapFree ? '<s>+' + KK.money(pr.giftwrap) + '</s> Most ajándék' : '+' + KK.money(pr.giftwrap), im.giftwrap,
          ''));   // J-92: üzenetkártya 2027-től, +490 Ft-ért; addig nincs kártya és üzenetmező
      }
      if (up.digital && photo.length && !has(v.digital)) list.push(upsellItem('digital', 'Digitálisan is', 'A terv nagy felbontású PNG-ben, e-mailben: megoszthatod, újranyomtathatod.', '+' + KK.money(pr.digital), im.digital));
      if (up.magnet4 && withPhotos.length && !has(v.magnet4)) list.push(upsellItem('magnet4', 'Ugyanazokból a fotókból: 4 hűtőmágnes', 'A kollázsod fotóiból készítjük, kis ajándéknak is jó.', '+' + KK.money(pr.magnet4), im.magnet4));
      const upBox = root.querySelector('[data-kk-upsell]');
      upBox.hidden = !list.length;
      root.querySelector('[data-kk-upsell-list]').innerHTML = list.slice(0, 3).join('');

      // Expressz (P-5): csak fizikai termékkel, díszcsomagolás nélkül
      const ex = root.querySelector('[data-kk-cx-express]');
      // Expressz csak expressz-képes termékcsoportnál; ha már a kosárban van, kivehető marad.
      if (up.express && (expressIn || physical.some((i) => KK.expressOk(KK.groupOf(i.product_type)))) && cfg.express && cfg.express.variant_id) {
        const blocked = has(v.giftwrap) && !expressIn;
        const soldOut = !cfg.express.available && !expressIn;
        const dated = KK.expressDated();
        ex.innerHTML = `<label class="kk-switch${blocked || soldOut ? ' is-blocked' : ''}"><input type="checkbox" role="switch" ${expressIn ? 'checked' : ''} ${blocked || soldOut ? 'disabled' : ''}>
          <span class="kk-switch__body"><span class="kk-switch__title">Expressz elkészítés</span><span class="kk-switch__sub">${dated ? `${cfg.express.cutoff}-ig rendelve ${cfg.express.days} munkanap alatt elkészítjük, MPL-lel küldjük` : 'Sorban elsőként készítjük el, MPL-lel küldjük'}</span></span>
          <span class="kk-switch__price">+${KK.money(cfg.express.price)}</span><span class="kk-switch__track" aria-hidden="true"></span></label>
          ${blocked ? '<p class="kk-switch__warn">A díszcsomagolás kézi munka, ezért expressz rendeléssel nem kérhető.</p>' : soldOut ? '<p class="kk-switch__warn">Mára betelt az expressz keret. Holnap újra választható.</p>' : ''}`;
      } else ex.innerHTML = '';

      // Ajándék jelölő
      // J-41: a jelölő csak kk_beallitasok.kosar_ajandek_jelolo = true esetén látszik; kikapcsolva a régi jelölést töröljük.
      const gf = root.querySelector('[data-kk-giftflag]');
      const giftOn = !!(cart.attributes && cart.attributes['Ajándékba'] === 'Igen');
      if (gf) gf.checked = giftOn;
      else if (giftOn) { try { fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ attributes: { 'Ajándékba': '' } }) }); } catch (err) {} }

      // Szállítás
      const ships = (cfg.shipping || []).filter((x) => x && x.name);
      const min = ships.length ? Math.min(...ships.map((x) => x.price)) : 0;
      // A szállítási sor a kosárfiókban a Digiloop választó alá kerülhet (placeShip), ezért a node-on tartott hivatkozásból dolgozunk.
      const shipRow = root._kkShip || root.querySelector('.kk-cartx__ship');
      // J-64: ha a kosár nem igényel szállítást (csak digitális tétel), a Digiloop választó rejtve (kk-no-ship, CSS).
      // A Shopify saját jelzőjéből dolgozunk (variáns: nem igényel szállítást), így a pénztár sem kér szállítást.
      const needsShip = cart.requires_shipping !== false;
      document.documentElement.classList.toggle('kk-no-ship', items.length > 0 && !needsShip);
      shipRow.querySelector('[data-kk-cx-ship]').textContent = needsShip
        ? `Szállítás ${KK.money(min)}-tól, a módot a pénztárban választod. Fizetés bankkártyával, Apple Pay-jel, Google Pay-jel vagy utánvéttel.`
        : 'Szállítás nem kell: a digitális fájlt e-mailben küldjük automatikusan pár órán belül. Fizetés bankkártyával, Apple Pay-jel vagy Google Pay-jel.';
      shipRow.hidden = !items.length;

      // J-66: digitális tétel elfogadás nélkül (pl. nem a termékoldali felugró ablakon át került be) -> kötelező jelölő.
      const digiLines = items.filter((i) => i.requires_shipping === false && i.handle !== 'tovabbi-kiegeszitok' && kindOf(i.variant_title || '') === 'digital');
      const acked = !!(cart.attributes && cart.attributes[DIGI_ATTR]);
      const pending = digiLines.length > 0 && !acked;
      KK.digiLines = digiLines.map((i) => ({ key: i.key, title: i.product_title, url: i.url, handle: i.handle }));
      if (KK.digiFinalSync) KK.digiFinalSync();
      const dg = root.querySelector('[data-kk-digi]');
      if (dg) { dg.hidden = !pending; const di = dg.querySelector('input'); if (!pending) { di.checked = false; di.disabled = false; } }
      if (document.documentElement.classList.contains('kk-digi-pending') !== pending) {
        document.documentElement.classList.toggle('kk-digi-pending', pending);
        document.dispatchEvent(new CustomEvent('kk:digi-state'));
      }
    };

    const wire = (root) => {
      root.addEventListener('click', async (e) => {
        const add = e.target.closest('[data-kk-up-add]');
        if (!add) return;
        const item = add.closest('[data-kk-up]'); const key = item.dataset.kkUp;
        const note = item.querySelector('.kk-upsell__note');
        if (key === 'giftwrap' && note && !item.classList.contains('is-open')) { item.classList.add('is-open'); add.textContent = 'Kérem'; note.querySelector('textarea').focus(); return; }
        add.disabled = true; item.setAttribute('aria-busy', 'true');
        const props = {};
        if (key === 'giftwrap') { const t = (note && note.querySelector('textarea').value.trim()) || ''; if (t) props['Üzenetkártya'] = t; }
        try { await KK.add(cfg.variants[key], 1, props); KK.track('kk_upsell_add', { item: key }); } catch (err) { add.disabled = false; item.removeAttribute('aria-busy'); }
      });
      root.addEventListener('change', async (e) => {
        if (e.target.matches('[data-kk-digi-input]')) {
          if (!e.target.checked) return;
          e.target.disabled = true;
          let handles = '';
          try { const c = await KK.cart(true); handles = [...new Set((c.items || []).filter((i) => i.requires_shipping === false && kindOf(i.variant_title || '') === 'digital').map((i) => i.handle))].join(', '); } catch (err) {}
          await KK.digiLog('kosár', handles);
          if (KK.digiFinalDone) KK.digiFinalDone();
          // Csak a kk-blokkok frissülnek; a Minimog kosár újrarajzolása kiürítené az ÁSZF-jelölőt.
          await KK.cart(true);
          document.dispatchEvent(new CustomEvent('kk:cart-changed'));
          return;
        }
        if (e.target.matches('[data-kk-plusz-input]')) {
          const on = e.target.checked; e.target.disabled = true;
          try {
            const c = await KK.cart(true);
            const u = {}; (c.items || []).filter((i) => mpVids.includes(i.variant_id)).forEach((l) => { u[l.variant_id] = 0; });
            if (on) {
              const phys = (c.items || []).filter((i) => !nonMain.has(i.product_id) && !i.gift_card && !/digit/i.test((i.options_with_values && i.options_with_values[0] && i.options_with_values[0].value) || ''));
              const vid = mpVidFor(mpFee(phys.reduce((a, i) => a + (i.final_line_price != null ? i.final_line_price : i.line_price), 0)));
              if (vid) u[vid] = 1;
            }
            await mpSync(u);
            KK.track('kk_mosoly_plusz', { on });
          } catch (err) { e.target.checked = !on; e.target.disabled = false; }
          return;
        }
        if (e.target.matches('[data-kk-giftflag]')) {
          const on = e.target.checked;
          try { await fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ attributes: { 'Ajándékba': on ? 'Igen' : '' } }) }); KK.track('kk_gift_flag', { on }); } catch (err) {}
        } else if (e.target.closest('.kk-switch')) {
          const sw = e.target; sw.disabled = true;
          try {
            if (sw.checked) await KK.add(cfg.express.variant_id, 1, {}); else await KK.removeVariant(cfg.express.variant_id);
            KK.track('kk_express_toggle', { on: sw.checked, where: 'cart' });
          } catch (err) { sw.checked = !sw.checked; sw.disabled = false; }
        }
      });
    };

    const mount = (footerId) => {
      const footer = document.getElementById(footerId);
      if (!footer) return;
      // Ha a Digiloop szállításimód-választója (#mapApp) ugyanebben a láblécben van (kosárfiók), a tájékoztató sor alá kerül;
      // a kosároldalon a placeMap (J-114) teszi a láblécbe, utána ugyanígy.
      const placeShip = (node) => {
        const ship = node && node._kkShip;
        if (!ship) return;
        const map = footer.querySelector('#mapApp');
        if (map && map.parentElement) { if (map.nextElementSibling !== ship) map.after(ship); }
        else if (ship.parentElement !== node) node.appendChild(ship);
      };
      // J-114: a kosároldalon a Digiloop app blokk a sablon külön Apps szekciójában, a lap alján van (a cart-template nem fogad
      // app blokkot). Az egész app blokkot (benne a #mapApp) a jobb oldali összesítőbe tesszük, a kk-blokk (Mosoly Plusz) alá;
      // a placeShip így a tájékoztató sort alá rakja, mint a kosárfiókban. A kiürült Apps szekció rejtve (kk-moved-out).
      // Az elem ugyanaz marad (nem másolat), így a Digiloop állapota és eseménykezelői megmaradnak; ha a Minimog újrarajzolja
      // a láblécet, a megfigyelő visszateszi.
      let mapBlk = null;
      const mapBlock = () => {
        if (footerId !== 'MinimogCartFooter') return null;
        if (!mapBlk) {
          const m = document.querySelector('main .m-app-section #mapApp');
          mapBlk = m ? (m.closest('.shopify-app-block') || m) : null;
          const sec = mapBlk && mapBlk.closest('.shopify-section');
          if (sec) sec.classList.add('kk-moved-out');
        }
        return mapBlk;
      };
      const placeMap = (node) => {
        const b = mapBlock();
        if (b && node.parentElement && node.nextElementSibling !== b) node.after(b);
      };
      const place = () => {
        let node = nodes.get(footerId);
        if (!node) { node = build(); wire(node); nodes.set(footerId, node); }
        const summary = footer.querySelector('.m-cart__summary');
        if (!summary) return;
        // a kk-blokk az összesítő előtt legyen (közte állhat a Digiloop blokk és a tájékoztató sor)
        if (node.parentElement !== summary.parentElement || !(node.compareDocumentPosition(summary) & Node.DOCUMENT_POSITION_FOLLOWING)) summary.parentElement.insertBefore(node, summary);
        placeMap(node);
        placeShip(node);
        render(node);
      };
      place();
      new MutationObserver(() => { const node = nodes.get(footerId); if (!node || !footer.contains(node)) place(); else { placeMap(node); placeShip(node); } }).observe(footer, { childList: true, subtree: true });
    };
    mount('MinimogCartFooter');
    mount('MinimogCartDrawerFooter');
    // J-66: amíg a digitális tétel nincs elfogadva, a pénztár gomb a jelölőhöz görget (kosároldal, kosárfiók, ragadós sáv).
    window.addEventListener('click', (e) => {
      if (!document.documentElement.classList.contains('kk-digi-pending')) return;
      const t = e.target && e.target.closest && e.target.closest('button[name="checkout"], input[name="checkout"], a[href$="/checkout"]');
      if (!t) return;
      e.preventDefault(); e.stopImmediatePropagation();
      const box = [...document.querySelectorAll('[data-kk-digi]')].find((x) => !x.hidden && x.offsetParent !== null);
      if (box) flashEl(box);
      KK.track('kk_digital_gate', {});
    }, true);
    document.addEventListener('kk:cart-changed', () => nodes.forEach((n) => render(n)));
    document.addEventListener('cart:updated', () => nodes.forEach((n) => render(n)));
  }


  /* ---------- CRO események a Teeinblue körül (09-cro-meresi-terv) ----------
     Shopify customer events (Shopify.analytics.publish); a továbbítást egy egyedi pixel végzi. */
  /* P-8: a LED és az akasztó kiemelése A4 és 30x40 keretes változatnál (előre nem jelöljük be) */
  function markAddons() {
    const o = KK.selectedOptions();
    const framed = /keret/i.test(o[1] || '') && !/digit|nyomat/i.test(o[0] || '');
    const big = /21x30|30x40/.test(o[2] || '');
    document.querySelectorAll('.tee-field').forEach((f) => {
      const head = ((f.querySelector('.tee-field__heading > span') || {}).textContent || '').toLowerCase();
      const isAddon = /led|akaszt/.test(head);
      f.classList.toggle('kk-tee-rec', isAddon && framed && big);
    });
  }
  function initTeeEvents() {
    setTimeout(markAddons, 1500); onVariant(markAddons);
    document.addEventListener('change', (e) => {
      const r = e.target;
      if (!r || r.type !== 'radio' || !r.closest) return;
      const f = r.closest('.tee-field'); if (!f) return;
      const head = ((f.querySelector('.tee-field__heading > span') || {}).textContent || '').toLowerCase();
      const lab = (((f.querySelector(`label[for="${CSS.escape(r.id)}"]`) || r.parentElement || {}).textContent) || '').trim();
      let addon = null;
      if (/led/.test(head)) addon = 'led'; else if (/akaszt/.test(head)) addon = 'akaszto'; else if (/díszcsomag/.test(head)) addon = 'diszcsomagolas'; else if (/digitális/.test(head)) addon = 'digitalis'; else if (/nfc/.test(head)) addon = 'nfc';
      if (addon) KK.track('kk_addon_toggle', { addon, on: !/^nem/i.test(lab) });
    }, true);
    document.addEventListener('click', (e) => {
      const b = e.target.closest && e.target.closest('button, a');
      if (b && b.closest('.tee-campaign, .tee-form-actions, [class*="tee-"]') && /előnézet|preview/i.test(b.textContent || '')) KK.track('kk_preview_open', {});
    }, true);
  }


  /* ---------- Szabadság: felső sáv és felugró ablak (J-100) ---------- */
  KK.vac.note = () => {
    if (!VAC) return '';
    const rng = `${fd(pd(VAC.start))} és ${fd(pd(VAC.end))} között`;
    if (KK.vac.preVacOk()) return `Szabadság: ${rng} nem gyártunk. Ha ${KK.vac.lastOrderTxt()}-ig rendelsz, még előtte feladjuk.`;
    return `Szabadság miatt ${rng} nem gyártunk, a rendelésed ${fdx(KK.vac.resume(), 'tol', true)} érkezési sorrendben készül.`;
  };
  // J-102: a CookieYes lebegő ikonja rejtve (CSS), a hozzájárulás a lábléc „Süti beállítások” linkjéről módosítható.
  function initCookieLink() {
    document.addEventListener('click', (e) => {
      const a = e.target.closest && e.target.closest('a[href*="#suti-beallitasok"]');
      if (!a) return;
      e.preventDefault();
      if (typeof window.revisitCkyConsent === 'function') window.revisitCkyConsent();
      else { const b = document.querySelector('.cky-btn-revisit'); if (b) b.click(); }
    });
    document.querySelectorAll('a[href*="#suti-beallitasok"]').forEach((a) => { a.setAttribute('role', 'button'); a.setAttribute('aria-haspopup', 'dialog'); });
  }

  function initVacation() {
    const ph = KK.vac.phase();
    if (ph === 'none' || /\/(checkouts|account)/.test(location.pathname)) return;
    const st = pd(VAC.start), en = pd(VAC.end), res = KK.vac.resume();
    const cap = (t) => t.charAt(0).toUpperCase() + t.slice(1);
    const rng = `${fd(st)} és ${fd(en)} között`;
    const pre = KK.vac.preVacOk();
    const dig = VAC.digital !== false;
    const barTxt = ph === 'on'
      ? `<strong>Szabadságon vagyunk ${fdx(en, 'ig')}.</strong> Rendelj nyugodtan, ${fdx(res, 'tol')} érkezési sorrendben készítjük.`
      : pre
        ? `<strong>${cap(rng)} szabadságon leszünk.</strong> Ha ${KK.vac.lastOrderTxt()}-ig rendelsz, még előtte feladjuk.`
        : `<strong>${cap(rng)} szabadságon leszünk.</strong> Rendelni ilyenkor is tudsz, ${fdx(res, 'tol')} érkezési sorrendben készítjük.`;
    const bar = document.createElement('div');
    bar.className = 'kk-vac-bar'; bar.setAttribute('role', 'status');
    bar.innerHTML = `<div class="kk-vac-bar__in"><span class="kk-vac-bar__txt">${barTxt}</span><button type="button" class="kk-vac-bar__more" data-kk-vac-open>Részletek</button></div>`;
    document.body.prepend(bar);

    let dlg = null;
    const open = () => {
      if (!dlg) {
        const items = [
          `<strong>${cap(fdw(st))} és ${fdw(en)} között</strong> szabadságon vagyunk, ilyenkor nem gyártunk és nem adunk fel csomagot.`,
          pre ? `Ha <strong>${KK.vac.lastOrderTxt()}-ig</strong> rendelsz, még a szabadság előtt feladjuk.` : '',
          `<strong>A rendelés zavartalan:</strong> amit közben leadsz, azt <strong>${fdx(res, 'tol', true)}</strong> érkezési sorrendben készítjük el. A termékoldalon már a pontos várható dátumot látod.`,
          dig ? '<strong>Digitális fájlt</strong> szabadság alatt is kérhetsz, 24 órán belül e-mailben küldjük.' : '',
          VAC.msg ? String(VAC.msg).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c])) : ''
        ].filter(Boolean).map((t) => `<li>${t}</li>`).join('');
        dlg = document.createElement('dialog');
        dlg.className = 'kk-digi-modal kk-vac-modal'; dlg.setAttribute('aria-labelledby', 'kk-vac-title');
        dlg.innerHTML = `<form method="dialog" class="kk-digi-modal__box">
          <button type="submit" value="cancel" class="kk-digi-modal__x" aria-label="Bezárás">&times;</button>
          <p class="kk-digi-modal__eyebrow"><span>${ph === 'on' ? 'Szabadság' : 'Hamarosan szabadság'}</span></p>
          <h2 id="kk-vac-title" class="kk-digi-modal__title">${ph === 'on' ? 'Szabadságon vagyunk, de rendelhetsz' : 'Hamarosan szabadságra megyünk'}</h2>
          <ul class="kk-digi-modal__list">${items}</ul>
          <div class="kk-digi-modal__actions"><button type="submit" value="ok" class="kk-digi-modal__ok">Rendben, értem</button></div>
        </form>`;
        document.body.appendChild(dlg);
        dlg.addEventListener('click', (ev) => { if (ev.target === dlg) dlg.close('cancel'); });
      }
      if (!dlg.open) { try { dlg.showModal(); } catch (e) { dlg.setAttribute('open', ''); } }
    };
    bar.querySelector('[data-kk-vac-open]').addEventListener('click', () => { open(); KK.track('kk_vacation_popup', { via: 'bar', phase: ph }); });
    // Szabadság alatt magától is megnyílik (J-100, Csongor 2026-10-20 19:19): látogatónként legfeljebb 2-szer,
    // két megjelenés között legalább 1 óra; a süti-hozzájárulás után 2,5 másodperccel.
    // Termékoldalon (19:33 módosítás) csak akkor, ha a látogató 3 másodperce nem csinál semmit és nem gépel.
    const isPdp = /\/products\//.test(location.pathname);
    if (ph === 'on') {
      const key = 'kk_vac_pop_' + VAC.start;
      let st = { n: 0, t: 0 }; try { st = JSON.parse(localStorage.getItem(key) || '{"n":0,"t":0}'); } catch (e) {}
      if ((st.n || 0) < 2 && Date.now() - (st.t || 0) >= 36e5) {
        const consentDone = () => /action:yes/.test(document.cookie || '');
        const ckyOpen = () => { const c = document.querySelector('.cky-consent-container'); return !!c && !c.classList.contains('cky-hide'); };
        let done = false, idleT = 0, hardT = 0;
        const typing = () => { const el = document.activeElement; return !!el && (/^(INPUT|TEXTAREA|SELECT)$/.test(el.tagName) || el.isContentEditable); };
        const shown = (el) => { const r = el.getBoundingClientRect(), cs = getComputedStyle(el); return r.width > 0 && r.height > 0 && cs.visibility !== 'hidden' && cs.display !== 'none' && +cs.opacity > 0.05; };
        // A CookieYes rejtett beállításpanelje is aria-modal, ezt kihagyjuk (a süti-ablakot külön figyeljük).
        const otherModal = () => !!document.querySelector('dialog[open]') || [...document.querySelectorAll('[aria-modal="true"]')].some((el) => !el.closest('[class*="cky-"]') && shown(el));
        const retry = () => { clearTimeout(hardT); hardT = setTimeout(tryAuto, 1500); };
        const tryAuto = () => {
          if (done) return;
          if (!consentDone() && ckyOpen()) return; // a süti-ablak még kint van: a döntés után újraindul
          if (otherModal() || typing()) { retry(); return; } // gépelés vagy másik ablak alatt nem, 1,5 mp múlva újra próbálja
          done = true; clearTimeout(idleT); clearTimeout(hardT);
          open(); KK.track('kk_vacation_popup', { via: 'auto', phase: ph, n: (st.n || 0) + 1, pdp: isPdp });
          try { localStorage.setItem(key, JSON.stringify({ n: (st.n || 0) + 1, t: Date.now() })); } catch (e) {}
        };
        // Termékoldalon (19:38): 3 mp tétlenség után, de legkésőbb 8 mp múlva mindenképp (gépelés közben soha).
        const later = () => { if (done) return; clearTimeout(idleT); idleT = setTimeout(tryAuto, isPdp ? 3000 : 2500); };
        const armHard = () => { if (!isPdp || done) return; clearTimeout(hardT); hardT = setTimeout(tryAuto, 8000); };
        document.addEventListener('cookieyes_consent_update', () => { later(); armHard(); });
        if (isPdp) ['pointerdown', 'keydown', 'scroll', 'touchstart', 'input', 'wheel'].forEach((ev) => addEventListener(ev, later, { passive: true, capture: true }));
        later(); armHard();
      }
    }
  }

  /* ---------- Landingek: várható kézbesítés és hirdetési címváltozat (10-landing-lista) ---------- */
  function initLanding() {
    document.querySelectorAll('[data-kk-dlv-mini]').forEach((el) => {
      const e = KK.estimate({ group: el.dataset.group || 'Falikép' });
      const rng = iso(e.delA) === iso(e.delB) ? fd(e.delA, true) : fr(e.delA, e.delB);
      el.querySelector('[data-kk-dlv-mini-txt]').innerHTML = (e.beforeCutoff ? `Ma ${e.cutoff}-ig rendelve` : 'Most rendelve') + ` várhatóan <strong>${rng}</strong> nálad`;
    });
    const map = document.querySelector('script[data-kk-msgmatch]');
    if (!map) return;
    let m = {}; try { m = JSON.parse(map.textContent); } catch (e) { return; }
    const qs = new URLSearchParams(location.search);
    const key = (qs.get('kk_h') || qs.get('utm_content') || '').toLowerCase().trim();
    const h1 = document.querySelector('[data-kk-h1]');
    if (!key || !h1 || !Object.prototype.hasOwnProperty.call(m, key) || typeof m[key] !== 'string') return;
    const esc = (t) => t.replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
    h1.innerHTML = esc(m[key]).replace(/\*(.+?)\*/g, '<em>$1</em>');
    KK.track('kk_msgmatch', { key });
  }


  /* ---------- Termékválasztó (kk-product-tabs): azonnali fülváltás ----------
     A nem alapértelmezett fülek tartalmát a Section Rendering API-ból töltjük elő
     (/collections/<handle>?section_id=kk-tab-panel), amikor a szekció a képernyő közelébe ér. */
  function initProductTabs(root) {
    const tabs = [...root.querySelectorAll('.kk-ptabs__tab')];
    const track = root.querySelector('[data-kk-ptabs-track]');
    const more = root.querySelector('[data-kk-ptabs-more]');
    const prev = root.querySelector('[data-kk-ptabs-prev]'), next = root.querySelector('[data-kk-ptabs-next]');
    const limit = parseInt(root.dataset.limit, 10) || 8;
    const cache = new Map();
    cache.set(track.dataset.handle, Promise.resolve(track.innerHTML));
    const load = (h) => {
      if (!cache.has(h)) {
        cache.set(h, fetch(`/collections/${encodeURIComponent(h)}?section_id=kk-tab-panel`, { credentials: 'same-origin' })
          .then((r) => (r.ok ? r.text() : Promise.reject(r.status)))
          .then((html) => {
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const items = [...doc.querySelectorAll('.kk-ptabs__item')].slice(0, limit);
            return items.length ? items.map((i) => i.outerHTML).join('') : '<p class="kk-ptabs__empty">Ebben a kategóriában most nincs termék.</p>';
          })
          .catch((e) => { cache.delete(h); throw e; }));
      }
      return cache.get(h);
    };
    const arrows = () => {
      if (!prev || !next) return;
      prev.hidden = track.scrollLeft < 8;
      next.hidden = track.scrollLeft + track.clientWidth >= track.scrollWidth - 8;
    };
    const select = async (tab, focus) => {
      if (tab.getAttribute('aria-selected') === 'true') return;
      tabs.forEach((t) => { const on = t === tab; t.setAttribute('aria-selected', on); t.tabIndex = on ? 0 : -1; });
      if (focus) tab.focus();
      track.setAttribute('aria-labelledby', tab.id);
      if (more) { more.href = tab.dataset.url; more.textContent = tab.dataset.more; }
      const h = tab.dataset.handle;
      track.classList.add('is-loading');
      try {
        const html = await load(h);
        if (tab.getAttribute('aria-selected') !== 'true') return;
        track.innerHTML = html; track.dataset.handle = h; track.scrollLeft = 0;
      } catch (e) { location.href = tab.dataset.url; return; }
      track.classList.remove('is-loading'); arrows();
      KK.track('kk_tab_select', { tab: tab.dataset.title, handle: h });
    };
    tabs.forEach((t, i) => {
      t.addEventListener('click', () => select(t, false));
      /* hover / érintés: a HTML mellett az első képek is előtöltődnek, így a váltás képpel együtt azonnali */
      const warm = () => load(t.dataset.handle).then((html) => {
        const tmp = document.createElement('div'); tmp.innerHTML = html;
        [...tmp.querySelectorAll('img')].slice(0, 4).forEach((im) => { const w = new Image(); w.sizes = im.sizes; w.srcset = im.srcset; w.src = im.src; });
      }).catch(() => {});
      t.addEventListener('mouseenter', warm, { once: true });
      t.addEventListener('touchstart', warm, { once: true, passive: true });
      t.addEventListener('keydown', (e) => {
        const g = [...t.parentElement.querySelectorAll('.kk-ptabs__tab')], n = g.indexOf(t);
        const k = e.key; let j = null;
        if (k === 'ArrowRight') j = (n + 1) % g.length; else if (k === 'ArrowLeft') j = (n - 1 + g.length) % g.length; else if (k === 'Home') j = 0; else if (k === 'End') j = g.length - 1;
        if (j !== null) { e.preventDefault(); select(g[j], true); }
      });
    });
    const step = () => track.clientWidth * 0.9;
    if (prev) prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
    if (next) next.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
    track.addEventListener('scroll', () => requestAnimationFrame(arrows), { passive: true });
    arrows();
    const bars = [...root.querySelectorAll('.kk-ptabs__tabs')];
    const visible = () => bars.find((b) => !b.hidden) || bars[0];
    const center = (bar, t) => {
      if (!t || !bar || bar.scrollWidth <= bar.clientWidth) return;
      const br = bar.getBoundingClientRect(), tr = t.getBoundingClientRect();
      bar.scrollLeft = Math.max(0, bar.scrollLeft + tr.left - br.left - (br.width - tr.width) / 2);
    };
    center(visible(), tabs.find((t) => t.getAttribute('aria-selected') === 'true'));
    // A-40: közeledéskor csak az első 3 fül töltődik előre, a többi rámutatáskor vagy érintéskor (warm).
    const prefetchBar = (bar) => [...bar.querySelectorAll('.kk-ptabs__tab')].slice(0, 3).forEach((t, i) => setTimeout(() => load(t.dataset.handle).catch(() => {}), 150 * i));
    /* a látható csoport minden füle, a rejtett csoportból csak az alapfül (a kapcsoló első váltása is azonnali) */
    const prefetch = () => {
      const v = visible(); prefetchBar(v);
      bars.filter((b) => b !== v).forEach((b) => { const d = b.querySelector('[data-def]'); if (d) setTimeout(() => load(d.dataset.handle).catch(() => {}), 600); });
    };
    /* Kapcsoló (alkalom / terméktípus): a csoport utoljára választott, különben alapértelmezett fülére vált */
    const modes = [...root.querySelectorAll('.kk-ptabs__mode')];
    modes.forEach((m) => {
      const bar = bars.find((b) => b.dataset.group === m.dataset.group);
      if (!bar) return;
      const warmGroup = () => prefetchBar(bar);
      m.addEventListener('mouseenter', warmGroup, { once: true });
      m.addEventListener('touchstart', warmGroup, { once: true, passive: true });
      m.addEventListener('focus', warmGroup, { once: true });
      m.addEventListener('click', () => {
        if (m.getAttribute('aria-pressed') === 'true') return;
        const cur = visible();
        const last = cur && cur.querySelector('[aria-selected="true"]');
        if (cur && last) cur.dataset.last = last.id;
        modes.forEach((x) => x.setAttribute('aria-pressed', x === m));
        bars.forEach((b) => { b.hidden = b !== bar; });
        const t = (bar.dataset.last && bar.querySelector('#' + CSS.escape(bar.dataset.last))) || bar.querySelector('[data-def]') || bar.querySelector('.kk-ptabs__tab');
        if (t) { select(t, false); center(bar, t); }
        KK.track('kk_tab_mode', { mode: m.dataset.group });
      });
    });
    /* J-53: a kategóriasáv lapozhatóságának jelzése: nyilak, áttűnő szél, felirat, egyszeri finom meglökés */
    const wrap = root.querySelector('[data-kk-ptabs-tabwrap]');
    if (wrap) {
      const tp = wrap.querySelector('[data-kk-tabs-prev]'), tn = wrap.querySelector('[data-kk-tabs-next]');
      const hint = root.querySelector('[data-kk-ptabs-hint]'), htxt = hint && hint.querySelector('[data-kk-hint-txt]');
      let touched = false;
      const upd = () => {
        const b = visible(); if (!b) return;
        const max = b.scrollWidth - b.clientWidth, cp = b.scrollLeft > 6, cn = b.scrollLeft < max - 6;
        wrap.classList.toggle('can-prev', cp); wrap.classList.toggle('can-next', cn);
        if (tp) tp.hidden = !cp; if (tn) tn.hidden = !cn;
        if (hint) {
          hint.hidden = max <= 6;
          hint.classList.toggle('is-gone', touched);
          if (htxt) htxt.textContent = b.dataset.group === 'alkalom' ? 'Húzd oldalra, még több alkalom' : 'Húzd oldalra, még több terméktípus';
        }
      };
      const touch = () => { if (!touched) { touched = true; wrap.classList.add('is-used'); upd(); } };
      const go = (d) => { const b = visible(); touch(); b.scrollBy({ left: d * Math.max(160, b.clientWidth * 0.7), behavior: 'smooth' }); };
      if (tp) tp.addEventListener('click', () => go(-1));
      if (tn) tn.addEventListener('click', () => go(1));
      bars.forEach((b) => {
        b.addEventListener('scroll', () => requestAnimationFrame(upd), { passive: true });
        b.addEventListener('touchstart', touch, { passive: true });
        b.addEventListener('wheel', touch, { passive: true });
      });
      modes.forEach((m) => m.addEventListener('click', () => setTimeout(upd, 60)));
      window.addEventListener('resize', () => requestAnimationFrame(upd));
      upd();
      if (!matchMedia('(prefers-reduced-motion: reduce)').matches && 'IntersectionObserver' in window) {
        const nio = new IntersectionObserver((en) => {
          if (!en.some((x) => x.isIntersecting)) return;
          nio.disconnect();
          setTimeout(() => {
            const b = visible();
            if (touched || !b || b.scrollWidth - b.clientWidth < 40 || b.scrollLeft > 6) return;
            const start = b.scrollLeft;
            b.style.scrollSnapType = 'none'; /* a rácsúszás ne kapja el a visszaúton */
            b.scrollTo({ left: start + 72, behavior: 'smooth' });
            setTimeout(() => { if (!touched) b.scrollTo({ left: start, behavior: 'smooth' }); }, 750);
            setTimeout(() => { b.style.scrollSnapType = ''; upd(); }, 1700);
          }, 600);
        }, { threshold: 0.9 });
        nio.observe(wrap);
      }
    }
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver((en) => { if (en.some((x) => x.isIntersecting)) { io.disconnect(); (window.requestIdleCallback || setTimeout)(prefetch); } }, { rootMargin: '600px 0px' });
      io.observe(root);
    } else prefetch();
  }

  /* ---------- J-56: Mobilos lapozható sáv jelzése (Kinek keresel?): "tovább" nyíl, felirat, egyszeri meglökés ---------- */
  function initSwipe(wrap) {
    const sc = wrap.querySelector('.kk-mscroll'), nx = wrap.querySelector('[data-kk-swipe-next]');
    const hint = wrap.nextElementSibling && wrap.nextElementSibling.matches('[data-kk-swipe-hint]') ? wrap.nextElementSibling : null;
    if (!sc) return;
    let touched = false;
    const upd = () => {
      const max = sc.scrollWidth - sc.clientWidth, cn = sc.scrollLeft < max - 6;
      const on = getComputedStyle(sc).overflowX !== 'visible' && max > 6;
      wrap.classList.toggle('can-next', on && cn);
      if (nx) nx.hidden = !(on && cn);
      if (hint) { hint.hidden = !on; hint.classList.toggle('is-gone', touched); }
    };
    const touch = () => { if (!touched) { touched = true; wrap.classList.add('is-used'); upd(); } };
    if (nx) nx.addEventListener('click', () => { touch(); sc.scrollBy({ left: Math.max(140, sc.clientWidth * 0.6), behavior: 'smooth' }); });
    sc.addEventListener('scroll', () => requestAnimationFrame(upd), { passive: true });
    sc.addEventListener('touchstart', touch, { passive: true });
    window.addEventListener('resize', () => requestAnimationFrame(upd));
    upd();
    if (!matchMedia('(prefers-reduced-motion: reduce)').matches && 'IntersectionObserver' in window) {
      const io = new IntersectionObserver((en) => {
        if (!en.some((x) => x.isIntersecting)) return;
        io.disconnect();
        setTimeout(() => {
          if (touched || sc.scrollWidth - sc.clientWidth < 40 || sc.scrollLeft > 6 || getComputedStyle(sc).overflowX === 'visible') return;
          const start = sc.scrollLeft;
          sc.style.scrollSnapType = 'none';
          sc.scrollTo({ left: start + 64, behavior: 'smooth' });
          setTimeout(() => { if (!touched) sc.scrollTo({ left: start, behavior: 'smooth' }); }, 750);
          setTimeout(() => { sc.style.scrollSnapType = ''; upd(); }, 1700);
        }, 600);
      }, { threshold: 0.6 });
      io.observe(sc);
    }
  }

  /* ---------- Hero képváltás (kk-hero: grid_rotate / polaroid) ----------
     A további termékképek egy <template>-ben várnak; a következő kör képeit egy körrel előbb töltjük be
     és dekódoljuk, így a váltás sosem villan. Csak akkor fut, ha a hero látszik és a lap előtérben van. */
  function initHeroRotate(root) {
    if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const mode = root.dataset.kkHeroRotate;
    const every = Math.max(2, parseFloat(root.dataset.interval) || 5) * 1000;
    const slots = [...root.querySelectorAll('[data-kk-slot]')];
    const tpl = root.querySelector('template[data-kk-hero-pool]');
    if (!slots.length || !tpl) return;
    const pool = slots.map((s) => s.querySelector('img')).filter(Boolean).map((i) => i.cloneNode())
      .concat([...tpl.content.querySelectorAll('img')]);
    if (pool.length <= slots.length) return;
    const wait = (ms) => new Promise((r) => setTimeout(r, ms));
    const prep = (src) => {
      const im = document.importNode(src, false); im.loading = 'eager'; /* a <template> tartalma inert: importálni kell, hogy betöltsön */ im.removeAttribute('fetchpriority');
      const ready = Promise.race([im.decode ? im.decode().catch(() => {}) : Promise.resolve(), wait(6000)]);
      return { im, ready };
    };
    const n = slots.length, len = pool.length;
    let ptr = n, turn = 0, timer = null, inView = false, busy = false;
    /* polaroid: egyenként, ebben a sorrendben cseréljük; a frissen leesett kerül a kupac tetejére */
    const order = [0, 4, 1, 3, 2].filter((i) => i < n);
    const stack = slots.slice();
    const restack = () => stack.forEach((s, i) => { s.style.zIndex = i + 1; });
    /* Vegyes kategóriák (data-cats): minden körben n különböző kategória, a cellák kategóriája körönként keveredik */
    let pick = null;
    if (mode === 'grid_rotate' && root.dataset.cats) {
      const lists = {};
      tpl.content.querySelectorAll('img[data-cat]').forEach((im) => { (lists[im.dataset.cat] = lists[im.dataset.cat] || []).push(im); });
      const cs = root.dataset.cats.split(',').filter((c) => lists[c] && lists[c].length);
      if (cs.length >= n) {
        const ptrs = {}; cs.forEach((c, i) => { ptrs[c] = i < n ? 1 : 0; });
        let prev = cs.slice(0, n), r = 0;
        pick = () => {
          r++;
          const set = Array.from({ length: n }, (_, i) => cs[(r * n + i) % cs.length]);
          let best = set;
          for (let t = 0; t < 24; t++) {
            const sh = set.slice(); for (let i = sh.length - 1; i > 0; i--) { const j = Math.floor(Math.random() * (i + 1)); [sh[i], sh[j]] = [sh[j], sh[i]]; }
            if (sh.every((c, i) => c !== prev[i])) { best = sh; break; }
          }
          prev = best;
          return best.map((c) => { const l = lists[c]; return l[ptrs[c]++ % l.length]; });
        };
      }
    }
    let next = null;
    const queue = () => {
      if (mode === 'polaroid') next = [prep(pool[ptr % len])];
      else if (pick) next = pick().map(prep);
      else next = Array.from({ length: n }, (_, i) => prep(pool[(ptr + i) % len]));
    };
    const tick = async () => {
      if (busy) return; busy = true;
      try {
        const batch = next; await Promise.all(batch.map((b) => b.ready));
        if (mode === 'polaroid') {
          let k = 0; while (k < order.length && !slots[order[turn % order.length]].offsetWidth) { turn++; k++; } /* rejtett (mobilon) polaroidot kihagyjuk */
          const slot = slots[order[turn % order.length]], card = slot.querySelector('.kk-pol__card'), box = slot.querySelector('.kk-pol__img');
          card.classList.add('is-out'); await wait(460);
          box.replaceChildren(batch[0].im);
          stack.splice(stack.indexOf(slot), 1); stack.push(slot); restack();
          card.classList.remove('is-out'); card.classList.add('is-pre'); void card.offsetWidth; card.classList.remove('is-pre');
          ptr++; turn++;
        } else {
          batch.forEach((b, i) => setTimeout(() => {
            const cell = slots[i], old = [...cell.querySelectorAll('img')];
            b.im.classList.add('kk-swap'); cell.appendChild(b.im); void b.im.offsetWidth; b.im.classList.add('is-on');
            setTimeout(() => old.forEach((o) => o.remove()), 1000);
          }, i * 140));
          ptr += n;
        }
        queue();
      } finally { busy = false; }
    };
    const loop = () => { clearTimeout(timer); if (inView && !document.hidden) timer = setTimeout(async () => { await tick(); loop(); }, every); };
    const start = () => {
      if (mode === 'polaroid') restack();
      queue();
      if ('IntersectionObserver' in window) new IntersectionObserver((en) => { inView = en[0].isIntersecting; loop(); }, { threshold: 0.25 }).observe(root);
      else { inView = true; loop(); }
      document.addEventListener('visibilitychange', loop);
    };
    /* a váltás a teljes betöltés ÉS az első interakció (görgőzés, koppintás, érintés, billentyű; a programból indított görgetés nem számít) után indul:
       addig a böngésző minden újonnan megjelenő képet LCP-jelöltnek vesz (J-32) */
    const afterLoad = () => KK.onFirstInput(start);
    if (document.readyState === 'complete') afterLoad(); else window.addEventListener('load', afterLoad, { once: true });
  }

  /* ---------- Hero lebegő vélemény váltakozva (data-kk-float-rotate) ----------
     Csak látható hero és előtérben lévő lap esetén vált; egérrel fölé állva megáll; csökkentett mozgásnál áll. */
  function initFloatRotate(el) {
    if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const items = [...el.querySelectorAll('.kk-float__item')];
    if (items.length < 2) return;
    const every = Math.max(4, parseFloat(el.dataset.interval) || 7) * 1000;
    let i = Math.max(0, items.findIndex((x) => x.classList.contains('is-on'))), timer = null, inView = false, hover = false;
    const show = (j) => items.forEach((x, k) => { const on = k === j; x.classList.toggle('is-on', on); if (on) x.removeAttribute('aria-hidden'); else x.setAttribute('aria-hidden', 'true'); });
    const loop = () => { clearTimeout(timer); if (inView && !hover && !document.hidden) timer = setTimeout(() => { i = (i + 1) % items.length; show(i); loop(); }, every); };
    el.addEventListener('mouseenter', () => { hover = true; loop(); });
    el.addEventListener('mouseleave', () => { hover = false; loop(); });
    document.addEventListener('visibilitychange', loop);
    if ('IntersectionObserver' in window) new IntersectionObserver((en) => { inView = en[0].isIntersecting; loop(); }, { threshold: 0.3 }).observe(el);
    else { inView = true; loop(); }
  }

  /* ---------- Szezonális menüpont (?kk=szezon jelölésű link) ---------- */
  function initSeason() {
    const links = document.querySelectorAll('a[href*="kk=szezon"]');
    if (!links.length) return;
    const today = iso(bpNow().day).slice(5);
    const rule = (cfg.season_menu || []).find((r) => (r.from <= r.to ? today >= r.from && today <= r.to : today >= r.from || today <= r.to));
    links.forEach((a) => {
      a.classList.add('kk-season-link');
      if (!rule) return;
      a.href = rule.url;
      const t = a.querySelector('.m-menu__link-title, span') || a;
      if (t.childElementCount === 0) t.textContent = rule.label; else a.setAttribute('aria-label', rule.label);
    });
  }

  /* ---------- Ragadós alsó sáv mobilon (termékoldal, 2026-10-02) ----------
     Ár + fotószámláló + egy gomb. Amíg van üres fotómező: „Következő fotó”
     (odagörget és megnyitja a fotóválasztót); utána „Kosárba teszem”, ami a
     Teeinblue saját Kosárba gombját nyomja meg, így a személyre szabás és a
     validáció (initMissing) változatlanul működik. A Minimog saját ragadós
     sávja ki van kapcsolva (saját űrlappal tenne kosárba, személyre szabás nélkül).
     Csak 750 px alatt (CSS), csak ha a valódi gomb nincs a képernyőn. */
  /* ---------- J-104: hiányzó kötelező mező jelzése a Kosárba gombnál ----------
     A Teeinblue a hibát a gomb alatt vagy a mezőnél jelzi, de nem görget oda: a ragadós
     sávról kattintva a vásárló nem látta, mi a baj. Kattintás után (valódi gomb és sáv
     egyaránt) megkeressük az első hibát, odagörgetünk, kiemeljük, és alul üzenetben
     megírjuk, mi hiányzik. A Teeinblue ellenőrzése marad a döntő, mi csak megmutatjuk. */
  function initAtcGuard() {
    const reduce = () => matchMedia('(prefers-reduced-motion: reduce)').matches;
    const vis = (e) => e && e.offsetParent !== null;
    const clean = (t) => String(t || '').replace(/\s+/g, ' ').trim();
    const titleOf = (f) => {
      const lab = f.querySelector('.tee-field__heading > span, .tee-field__label, .tee-field-label');
      let t = clean((lab || f).textContent).split('*')[0].trim();
      if (t.length > 70) { const q = t.indexOf('?'); t = q > 10 && q < 110 ? t.slice(0, q + 1) : t.slice(0, 60).trim() + '…'; }
      return t;
    };
    const verbOf = (f) => {
      if (f.classList.contains('tee-field--photo') || f.querySelector('input[type=file], .tee-photo-placeholder')) return 'Tölts fel fotót ide';
      if (f.classList.contains('tee-field--text') || f.querySelector('textarea')) return 'Töltsd ki ezt a mezőt';
      if (/tee-field--(moon_phase|star_map|map|date)/.test(f.className)) return 'Add meg ezt az adatot';
      return 'Válassz egy lehetőséget';
    };
    let toast, hideT;
    const show = (head, sub, target) => {
      if (!toast) {
        toast = document.createElement('div');
        toast.className = 'kk-need'; toast.setAttribute('role', 'alert');
        toast.innerHTML = '<span class="kk-need__ico" aria-hidden="true">!</span><button type="button" class="kk-need__txt"><strong></strong><span></span></button><button type="button" class="kk-need__x" aria-label="Bezárás">×</button>';
        document.body.appendChild(toast);
        toast.querySelector('.kk-need__x').addEventListener('click', () => toast.classList.remove('is-on'));
        toast.querySelector('.kk-need__txt').addEventListener('click', () => { if (toast._t) go(toast._t); });
      }
      toast.querySelector('strong').textContent = head;
      toast.querySelector('.kk-need__txt span').textContent = sub;
      toast._t = target;
      toast.classList.remove('is-on'); void toast.offsetWidth; toast.classList.add('is-on');
      clearTimeout(hideT); hideT = setTimeout(() => toast.classList.remove('is-on'), 7000);
    };
    const go = (el) => {
      const r = el.getBoundingClientRect();
      if (r.top < 120 || r.top > innerHeight * 0.6) window.scrollTo({ top: Math.max(0, scrollY + r.top - 130), behavior: reduce() ? 'auto' : 'smooth' }); // a felül megjelenő üzenet alá
      el.classList.remove('kk-flash'); void el.offsetWidth; el.classList.add('kk-flash');
      const inp = el.querySelector('input[type=checkbox], select, input[type=radio], textarea, input[type=text]');
      if (inp && inp.type !== 'text' && inp.tagName !== 'TEXTAREA') setTimeout(() => { try { inp.focus({ preventScroll: true }); } catch (e) { /* nem fókuszálható */ } }, 450);
    };
    const check = () => {
      const form = document.querySelector('.tee-form-wrapper'); if (!form) return false;
      const bad = [...form.querySelectorAll('.tee-field--invalid')].filter(vis);
      if (bad.length) {
        const f = bad[0];
        const more = bad.length > 1 ? ` (és még ${bad.length - 1} mező)` : '';
        go(f); show(verbOf(f) + more, '„' + titleOf(f) + '”', f);
        KK.track('kk_atc_blocked', { reason: 'field', count: bad.length });
        return true;
      }
      const conf = form.querySelector('input[name="confirmed"]');
      const err = [...form.querySelectorAll('.tee-form-responses .tee-error')].find(vis);
      if (conf && !conf.checked && vis(conf.closest('.tee-checkbox-wrapper') || conf)) {
        const box = conf.closest('.tee-checkbox-wrapper') || conf.parentElement;
        go(box); show('Pipáld be a megerősítő négyzetet', 'A kosár gomb felett, odagörgettünk.', box);
        KK.track('kk_atc_blocked', { reason: 'confirm' });
        return true;
      }
      if (err) { go(err); show('Valami még hiányzik', clean(err.textContent), err); KK.track('kk_atc_blocked', { reason: 'other' }); return true; }
      return false;
    };
    document.addEventListener('click', (e) => {
      if (!e.target.closest || !e.target.closest('.tee-btn--atc')) return;
      if (toast) toast.classList.remove('is-on');
      let n = 0;
      const tick = () => { if (check() || ++n > 12) return; setTimeout(tick, 120); };
      setTimeout(tick, 120);
    }, true);
  }

  function initStickyBar() {
    let tries = 0;
    const start = () => {
      const atc = document.querySelector('.tee-btn--atc');
      const form = document.querySelector('.tee-form-wrapper');
      if (!atc || !form) { if (tries++ < 40) setTimeout(start, 400); return; }
      const bar = document.createElement('div');
      bar.className = 'kk-sbar'; bar.setAttribute('aria-hidden', 'true');
      bar.innerHTML = '<div class="kk-sbar__info"><span class="kk-sbar__price" data-kk-sbar-price></span><span class="kk-sbar__count" data-kk-sbar-count></span></div><button type="button" class="kk-sbar__btn" data-kk-sbar-btn tabindex="-1"></button>';
      document.body.appendChild(bar);
      const priceEl = bar.querySelector('[data-kk-sbar-price]');
      const countEl = bar.querySelector('[data-kk-sbar-count]');
      const btn = bar.querySelector('[data-kk-sbar-btn]');
      const photos = () => [...form.querySelectorAll('.tee-field--photo')].filter((f) => f.offsetParent !== null);
      const empty = () => photos().filter((f) => f.querySelector('.tee-photo-placeholder'));
      const render = () => {
        const p = document.querySelector('.tee-price--current');
        priceEl.textContent = p ? p.textContent.trim() : '';
        const all = photos().length, left = empty().length;
        countEl.textContent = all ? `Fotók: ${all - left}/${all}` : '';
        countEl.classList.toggle('is-done', all > 0 && left === 0);
        btn.textContent = left ? 'Következő fotó' : 'Kosárba teszem';
        btn.dataset.mode = left ? 'photo' : 'atc';
      };
      render();
      new MutationObserver(() => { clearTimeout(render.t); render.t = setTimeout(render, 150); }).observe(form, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['class'] });
      btn.addEventListener('click', () => {
        if (btn.dataset.mode === 'photo') {
          const f = empty()[0];
          if (!f) return render();
          f.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' });
          const input = f.querySelector('input[type=file]');
          if (input) input.click();
          KK.track('kk_sbar_click', { action: 'photo', left: empty().length });
        } else {
          const real = document.querySelector('.tee-btn--atc');
          KK.track('kk_sbar_click', { action: 'atc' });
          if (real) real.click();
        }
      });
      // Látható, ha az űrlap teteje már elhagyta a képernyőt, és a valódi gomb nincs a képernyőn.
      let pastTop = false, atcIn = false;
      const update = () => {
        const on = pastTop && !atcIn;
        bar.classList.toggle('is-on', on);
        bar.setAttribute('aria-hidden', on ? 'false' : 'true');
        btn.tabIndex = on ? 0 : -1;
        document.body.classList.toggle('kk-sbar-on', on);
      };
      const anchor = document.querySelector('.tee-product-price, .tee-block') || form;
      new IntersectionObserver(([e]) => { pastTop = !e.isIntersecting && e.boundingClientRect.top < 0; update(); }).observe(anchor);
      new IntersectionObserver(([e]) => { atcIn = e.isIntersecting; update(); }, { rootMargin: '0px 0px -40px 0px' }).observe(atc.closest('.tee-form-action, .tee-form-actions') || atc);
    };
    start();
  }

  /* ---------- Kosártételek rendezése (2026-10-02) ----------
     A Teeinblue minden fotót külön tulajdonságként, teljes URL-lel ad át, és
     minden kiegészítő-kérdés „Nem” válasza is megjelenik: egy számos kollázs
     mobilon ~1 700 px magas tétel volt. Itt: a fotókból bélyegkép-sor lesz, a
     „Nem” válaszok rejtve, a variáns-opciók magyar címkét kapnak (az „Available
     Product” bolti átnevezéséig, B7). Csak megjelenítés, a rendelés adata nem változik. */
  const IMG_RE = /^https?:\/\/\S+\.(png|jpe?g|webp|gif|heic)(\?\S*)?$/i;
  KK.hasPhotos = (props) => Object.entries(props || {}).some(([k, v]) => !k.startsWith('_') && IMG_RE.test(String(v).trim()));
  const OPT_LABEL = { 'Available Product': 'Formátum', 'VÁLTOZAT': 'Keret', 'MÉRET': 'Méret' };
  function tidyCartItems(root) {
    // Kosároldal (ul/li) és kosár-panel (p elemek) egyaránt; a panelen a fotó link, a teljes cím a href-ben van.
    root.querySelectorAll('ul[data-cart-item-details]:not([data-kk-tidy]), .m-cart-drawer-item__variant:not([data-kk-tidy])').forEach((box) => {
      box.dataset.kkTidy = '1';
      const isUl = box.tagName === 'UL';
      box.querySelectorAll(isUl ? 'li[data-cart-item-option] > span' : '.m-cart-item__option > span').forEach((s) => {
        const raw = s.textContent.trim(); const key = raw.replace(/\s*:\s*$/, '');
        if (OPT_LABEL[key]) s.textContent = OPT_LABEL[key] + (/:\s*$/.test(raw) ? ': ' : '');
      });
      // J-66: formátum-jelzés a kosársorban (csak az opciók szövegéből, a vásárló által írt mezőkből nem).
      const optTxt = [...box.querySelectorAll(isUl ? 'li[data-cart-item-option]' : '.m-cart-item__option')].map((o) => o.textContent).join(' | ');
      const fk = kindOf(optTxt);
      if (fk === 'digital' || fk === 'print') {
        const badge = document.createElement(isUl ? 'li' : 'p');
        badge.className = 'kk-fmt-badge kk-fmt-badge--' + fk;
        badge.textContent = fk === 'digital' ? 'Digitális fájl: e-mailben kapod, postán nem küldünk semmit' : 'Csak a nyomat: fotópapír, képkeret nélkül';
        box.insertBefore(badge, box.firstChild);
      }
      const photos = [];
      box.querySelectorAll('[data-cart-item-property]').forEach((el) => {
        if (el.classList.contains('m:hidden')) return;
        const v = el.querySelector('[data-cart-item-property-value]');
        const link = v && v.querySelector('a[href]');
        const val = ((link && link.getAttribute('href')) || (v && v.textContent) || '').trim();
        if (val === 'Nem') { el.classList.add('kk-prop-hide'); return; }
        if (IMG_RE.test(val)) { photos.push(val); el.classList.add('kk-prop-hide'); }
      });
      if (photos.length) {
        const row = document.createElement(isUl ? 'li' : 'p');
        row.className = 'kk-cart-photos m:text-sm';
        const shown = photos.slice(0, 6);
        row.innerHTML = `<span class="m:font-medium">Fotóid (${photos.length}):</span><span class="kk-cart-photos__row">${shown.map((u) => `<img src="${u.replace(/"/g, '')}" alt="" width="30" height="30" loading="lazy" decoding="async">`).join('')}${photos.length > shown.length ? `<span class="kk-cart-photos__more">+${photos.length - shown.length}</span>` : ''}</span>`;
        box.insertBefore(row, box.querySelector('[data-cart-item-property]') || null);
      }
    });
  }
  function initCartTidy() {
    const run = () => tidyCartItems(document);
    run();
    new MutationObserver(() => { clearTimeout(run.t); run.t = setTimeout(run, 60); }).observe(document.body, { childList: true, subtree: true });
  }

  /* ---------- Ragadós pénztár-sáv mobilon (kosároldal) ----------
     Összeg + „Tovább a pénztárhoz”. Ha az ÁSZF-jelölő nincs bepipálva, odagörget
     és kiemeli; különben a Minimog valódi pénztár gombját nyomja meg. */
  function initCartBar() {
    if (!/\/cart\/?$/.test(location.pathname)) return;
    const real = () => [...document.querySelectorAll('.m-cart__container button[name="checkout"], main button[name="checkout"], button[name="checkout"]')].find((x) => x.offsetParent !== null);
    let tries = 0;
    const start = () => {
      const btn0 = real();
      if (!btn0) { if (tries++ < 20) setTimeout(start, 400); return; }
      const bar = document.createElement('div');
      bar.className = 'kk-sbar kk-sbar--cart'; bar.setAttribute('aria-hidden', 'true');
      bar.innerHTML = '<div class="kk-sbar__info"><span class="kk-sbar__count">Összesen</span><span class="kk-sbar__price" data-kk-cbar-total></span></div><button type="button" class="kk-sbar__btn" tabindex="-1">Tovább a pénztárhoz</button>';
      document.body.appendChild(bar);
      const totalEl = bar.querySelector('[data-kk-cbar-total]');
      const render = async () => { try { const c = await KK.cart(true); totalEl.textContent = KK.money(c.total_price); bar.hidden = !c.item_count; } catch (e) { /* hálózati hiba: marad az előző érték */ } };
      render();
      document.addEventListener('cart:refresh', render); document.addEventListener('kk:cart-updated', render);
      new MutationObserver(() => { clearTimeout(render.t); render.t = setTimeout(render, 300); }).observe(document.querySelector('.m-cart__items') || document.body, { childList: true, subtree: true, characterData: true });
      bar.querySelector('button').addEventListener('click', () => {
        // A Minimog ÁSZF-jelölője: input[name=agree_terms] (egyedi stílusú, a natív input rejtett)
        const b0 = real();
        const scope = (b0 && b0.closest('form')) || document;
        const agree = scope.querySelector('input[name="agree_terms"]') || document.querySelector('main input[name="agree_terms"]');
        if (agree && !agree.checked) {
          const box = agree.closest('label') || agree.parentElement || agree;
          box.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' });
          box.classList.remove('kk-flash'); void box.offsetWidth; box.classList.add('kk-flash');
          setTimeout(() => agree.focus({ preventScroll: true }), 400);
          KK.track('kk_cbar_click', { action: 'agree' });
          return;
        }
        KK.track('kk_cbar_click', { action: 'checkout' });
        const b = real(); if (b) b.click();
      });
      let inView = false;
      const update = () => { const on = !inView && !bar.hidden; bar.classList.toggle('is-on', on); bar.setAttribute('aria-hidden', on ? 'false' : 'true'); bar.querySelector('button').tabIndex = on ? 0 : -1; document.body.classList.toggle('kk-sbar-on', on); };
      const watch = () => { const b = real(); if (!b || b === watch.el) return; watch.el = b; new IntersectionObserver(([e]) => { inView = e.isIntersecting; update(); }, { rootMargin: '0px 0px -20px 0px' }).observe(b.closest('.m-cart__footer, .m-cart__summary') || b); };
      watch(); setInterval(watch, 2000);
    };
    start();
  }

  /* ---------- Gyorsfizetés (Google Pay) csak az ÁSZF elfogadása után (döntés: 2026-10-02, 1b) ----------
     A gyorsfizetés gombjai a Minimog ÁSZF-jelölőjétől függetlenül működtek. Amíg a
     jelölő nincs bepipálva, egy átlátszó réteg fedi őket: kattintásra a jelölőhöz
     görget és kiemeli. Kosároldalon és a drawerben is (mindkettő újrarajzolódhat). */
  function initAgreeGuard() {
    const flash = (agree) => {
      const box = agree.closest('label') || agree.parentElement || agree;
      box.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' });
      box.classList.remove('kk-flash'); void box.offsetWidth; box.classList.add('kk-flash');
      setTimeout(() => agree.focus({ preventScroll: true }), 400);
    };
    const apply = () => {
      document.querySelectorAll('.additional-checkout-buttons').forEach((wrap) => {
        const scope = wrap.closest('form, .m-cart__footer, .m-cart-drawer, .m-cart__container') || document;
        const agree = scope.querySelector('input[name="agree_terms"]');
        if (!agree) return;
        let guard = wrap.querySelector(':scope > .kk-agree-guard');
        if (!guard) {
          wrap.classList.add('kk-agree-wrap');
          guard = document.createElement('button');
          guard.type = 'button'; guard.className = 'kk-agree-guard';
          guard.setAttribute('aria-label', 'Gyorsfizetés: előbb fogadd el az ÁSZF-et');
          guard.addEventListener('click', (e) => {
            e.preventDefault(); KK.track('kk_agree_guard', {});
            // J-66: előbb a digitális fájl tudomásulvétele, utána az ÁSZF.
            const digi = document.documentElement.classList.contains('kk-digi-pending') && [...document.querySelectorAll('[data-kk-digi]')].find((x) => !x.hidden && x.offsetParent !== null);
            if (digi) flashEl(digi); else if (agree.checked && KK.digiFinalNeeded && KK.digiFinalNeeded()) KK.digiFinalOpen(null); else flash(agree);
          });
          wrap.appendChild(guard);
        }
        const ok = agree.checked && !document.documentElement.classList.contains('kk-digi-pending') && !(KK.digiFinalNeeded && KK.digiFinalNeeded());
        guard.hidden = ok;
        wrap.classList.toggle('is-locked', !ok);
        // A-23: lezárt állapotban a gombok billentyűzettel (Tab + Enter) sem érhetők el.
        [...wrap.children].forEach((c) => { if (c !== guard) c.toggleAttribute('inert', !ok); });
        if (!agree.dataset.kkGuard) { agree.dataset.kkGuard = '1'; agree.addEventListener('change', apply); }
      });
    };
    apply();
    document.addEventListener('kk:digi-state', apply);
    new MutationObserver(() => { clearTimeout(apply.t); apply.t = setTimeout(apply, 80); }).observe(document.body, { childList: true, subtree: true });
  }

  /* ---------- J-66: digitális és nyomat formátum figyelmeztetés (2026-10-19) ----------
     Termékoldal: a formátumválasztó alatt figyelmeztetés (digitális: erős, nyomat: tájékoztató),
     digitálisnál a kosárba tétel előtt felugró ablak kötelező jelölővel. Az elfogadást rendelés-
     attribútumként naplózzuk (DIGI_ATTR: időpont | forrás | termék | szövegverzió), így a rendelés
     adminjában is látszik. Kosár: soronkénti jelzés; ha digitális tétel van elfogadás nélkül
     (pl. a felugró ablak megkerülésével), kötelező jelölő a pénztár és a gyorsfizetés előtt. */
  const DIGI_ATTR = 'Digitális fájl tudomásul véve';
  const DIGI_VER = 'szöveg v2 (2026-10-21)';
  const DIGI_ACK_TXT = 'Értem: digitális fájlt rendelek, postán nem kapok semmit, a fájlt e-mailben kapom meg. Kérem, hogy az elkészítését azonnal kezdjétek meg, és tudomásul veszem, hogy ezután elállási jogom nincs.';
  const DIGI_RE = /digitális letölthető|png\/pdf|png fájl|\bdigit/i; // „PNG/PDF” régi érték, 2026-10-19 óta „PNG fájl”
  const PRINT_RE = /nyomat \(fotó\)|képkeret nélkül|csak fotópapír/i;
  const kindOf = (txt) => (/digitális nyomattal/i.test(txt) ? 'other' : DIGI_RE.test(txt) ? 'digital' : PRINT_RE.test(txt) ? 'print' : 'other');
  const reduceMotion = () => matchMedia('(prefers-reduced-motion: reduce)').matches;
  const flashEl = (box) => {
    box.scrollIntoView({ behavior: reduceMotion() ? 'auto' : 'smooth', block: 'center' });
    box.classList.remove('kk-flash'); void box.offsetWidth; box.classList.add('kk-flash');
    const inp = box.querySelector('input'); if (inp) setTimeout(() => inp.focus({ preventScroll: true }), 400);
  };
  const bpStamp = () => {
    try { return new Intl.DateTimeFormat('sv-SE', { timeZone: 'Europe/Budapest', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' }).format(new Date()); }
    catch (e) { return new Date().toISOString(); }
  };
  KK.digiLog = async (src, handle) => {
    let prev = '';
    try { const c = await KK.cart(true); prev = (c.attributes && c.attributes[DIGI_ATTR]) || ''; } catch (e) {}
    const entry = [bpStamp(), src, handle, DIGI_VER].filter(Boolean).join(' | ');
    const val = ((prev ? prev + ' ; ' : '') + entry).slice(-900);
    const ctl = 'AbortController' in window ? new AbortController() : null;
    const t = ctl ? setTimeout(() => ctl.abort(), 3000) : 0;
    try {
      await fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ attributes: { [DIGI_ATTR]: val } }), signal: ctl ? ctl.signal : undefined });
    } catch (e) {}
    clearTimeout(t);
    KK.track('kk_digital_ack', { src, handle: handle || '' });
  };
  KK.formatKindOf = kindOf;

  function initFormatNotice() {
    const dlv = document.querySelector('[data-kk-delivery]');
    const digitalIds = new Set(((dlv && dlv.dataset.digital) || '').split(',').filter(Boolean).map(Number));
    const handle = decodeURIComponent((location.pathname.match(/\/products\/([^/?#]+)/) || [])[1] || '');
    const curVariant = () => { const inp = document.querySelector('form[action*="/cart/add"] [name="id"]'); return inp ? Number(inp.value) : 0; };
    // A Teeinblue terméktípus-választója (Elérhető termékek) a kijelölést .tee-radio.active osztállyal jelzi, nem :checked-del.
    const apText = () => { const a = document.querySelector('.tee-available-products .tee-radio.active') || ((document.querySelector('.tee-available-products input:checked') || {}).parentElement); return a ? (a.textContent || '') : ''; };
    const kind = () => {
      const ap = apText();
      if (ap) return kindOf(ap); // ha van terméktípus-választó, az a mérvadó
      const k = kindOf(KK.selectedOptions().filter(Boolean).join(' | '));
      return k === 'other' && digitalIds.has(curVariant()) ? 'digital' : k;
    };
    const radioText = (r) => r.value + ' ' + ((r.closest('.tee-radio, label') || {}).textContent || '');
    const fmtGroup = () => {
      const ap = document.querySelector('.tee-available-products');
      if (ap && ap.offsetParent !== null) return ap;
      const g = teeGroups().find((x) => x.radios.some((r) => kindOf(radioText(r)) !== 'other'));
      return g ? g.el : null;
    };
    const note = document.createElement('div');
    note.className = 'kk-fmt-note'; note.hidden = true; note.setAttribute('role', 'status');
    const warnIc = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 3 2 21h20L12 3z"/><path d="M12 10v5M12 18h.01"/></svg>';
    const infoIc = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M12 11v6M12 7.5h.01"/></svg>';
    const NOTE = {
      digital: `<p class="kk-fmt-note__title">${warnIc}<span>Digitális fájlt választottál, nem keretes képet</span></p>
        <p>Nem kapsz képkeretet és nyomtatott képet, postán nem küldünk semmit. A kész képet PNG fájlként e-mailben küldjük, automatikusan, pár órán belül. Az ár csak a fájl ára.</p>
        <button type="button" class="kk-fmt-note__btn" data-kk-to-framed>Inkább keretes képet kérek</button>`,
      print: `<p class="kk-fmt-note__title">${infoIc}<span>Csak a nyomatot kapod, képkeret nélkül</span></p>
        <p>A képet fényes fotópapírra nyomtatjuk, keret nem jár hozzá. Ha kerettel kérnéd, válaszd a keretes falikép formátumot.</p>
        <button type="button" class="kk-fmt-note__btn" data-kk-to-framed>Keretes képet kérek</button>`
    };
    let last = '';
    const update = () => {
      const k = kind();
      const grp = fmtGroup();
      if (k === 'other') { note.hidden = true; last = k; return; }
      if (grp) { if (note.previousElementSibling !== grp) grp.after(note); }
      else if (dlv) { if (note.nextElementSibling !== dlv) dlv.before(note); }
      else return;
      if (k !== last || note.hidden) {
        note.innerHTML = NOTE[k]; note.className = 'kk-fmt-note kk-fmt-note--' + k; note.hidden = false;
        if (last) { void note.offsetWidth; note.classList.add('is-pulse'); }
        KK.track('kk_format_notice', { kind: k });
      }
      last = k;
    };
    const toFramed = () => {
      const grp = fmtGroup(); if (!grp) return;
      const t = [...grp.querySelectorAll('input[type="radio"]')].find((r) => /kerettel|falikép/i.test(radioText(r)) && kindOf(radioText(r)) === 'other');
      if (!t) return;
      const wrap = t.closest('.tee-radio');
      ((wrap && wrap.querySelector('label')) || t).click();
      KK.track('kk_format_switch', { to: 'framed' });
      setTimeout(update, 400);
      grp.scrollIntoView({ behavior: reduceMotion() ? 'auto' : 'smooth', block: 'center' });
    };
    note.addEventListener('click', (e) => { if (e.target.closest('[data-kk-to-framed]')) { e.preventDefault(); toFramed(); } });
    KK.fmtKind = kind; KK.apText = apText;

    onVariant(update);
    document.addEventListener('click', (e) => { if (e.target && e.target.closest && e.target.closest('.tee-available-products')) setTimeout(update, 400); }, true);
    const host = document.querySelector('.tee-form-wrapper, #tee-artwork-form') || document.body;
    new MutationObserver(() => { clearTimeout(update.t); update.t = setTimeout(update, 250); }).observe(host, { childList: true, subtree: true });
    [300, 1000, 2500].forEach((ms) => setTimeout(update, ms));

    // Felugró ablak a kosárba tétel előtt (csak digitálisnál, oldalbetöltésenként egyszer kell elfogadni).
    let accepted = false, dlg = null, pendingBtn = null;
    const buildDlg = () => {
      dlg = document.createElement('dialog');
      dlg.className = 'kk-digi-modal'; dlg.setAttribute('aria-labelledby', 'kk-digi-title');
      dlg.innerHTML = `<form method="dialog" class="kk-digi-modal__box">
        <button type="submit" value="cancel" class="kk-digi-modal__x" aria-label="Bezárás">&times;</button>
        <p class="kk-digi-modal__eyebrow">${warnIc}<span>Figyelem</span></p>
        <h2 id="kk-digi-title" class="kk-digi-modal__title">Digitális fájlt teszel a kosárba, nem keretes képet</h2>
        <ul class="kk-digi-modal__list">
          <li><strong>Nem kapsz képkeretet és nyomtatott képet,</strong> postán nem küldünk semmit.</li>
          <li>A kész képet <strong>PNG fájlként e-mailben</strong> küldjük, automatikusan, pár órán belül.</li>
          <li>Ha papíron szeretnéd, neked kell kinyomtatnod.</li>
          <li>Az ár <strong>csak a digitális fájl ára,</strong> keret és nyomat nélkül.</li>
        </ul>
        <label class="kk-digi-modal__ack"><input type="checkbox" data-kk-digi-modal-ack autofocus><span>${DIGI_ACK_TXT}</span></label>
        <div class="kk-digi-modal__actions">
          <button type="submit" value="ok" class="kk-digi-modal__ok" data-kk-digi-ok disabled>Elfogadom, kosárba teszem</button>
          <button type="submit" value="framed" class="kk-digi-modal__alt">Inkább keretes képet kérek</button>
        </div>
      </form>`;
      document.body.appendChild(dlg);
      const cb = dlg.querySelector('[data-kk-digi-modal-ack]'), ok = dlg.querySelector('[data-kk-digi-ok]');
      cb.addEventListener('change', () => { ok.disabled = !cb.checked; });
      dlg.addEventListener('click', (e) => { if (e.target === dlg) dlg.close('cancel'); });
      dlg.addEventListener('close', async () => {
        const v = dlg.returnValue; const btn = pendingBtn; pendingBtn = null;
        if (v === 'ok' && cb.checked) {
          accepted = true;
          KK.track('kk_digital_modal', { action: 'accept' });
          await KK.digiLog('termékoldal', handle);
          if (btn) btn.click();
        } else if (v === 'framed') { KK.track('kk_digital_modal', { action: 'framed' }); toFramed(); }
        else KK.track('kk_digital_modal', { action: 'cancel' });
      });
    };
    const ATC = '.tee-btn--atc, form[action*="/cart/add"] button[name="add"], form[action*="/cart/add"] [type="submit"]';
    window.addEventListener('click', (e) => {
      const btn = e.target && e.target.closest && e.target.closest(ATC);
      if (!btn || accepted || kind() !== 'digital') return;
      e.preventDefault(); e.stopImmediatePropagation();
      if (!dlg) buildDlg();
      if (typeof dlg.showModal !== 'function') {
        // Nagyon régi böngésző: natív megerősítő ablak ugyanazzal a szöveggel.
        if (window.confirm('Figyelem: digitális fájlt teszel a kosárba, nem keretes képet. Postán nem küldünk semmit, a fájlt e-mailben kapod meg. ' + DIGI_ACK_TXT)) {
          accepted = true; KK.digiLog('termékoldal', handle).then(() => btn.click());
        }
        return;
      }
      pendingBtn = btn; dlg.returnValue = '';
      dlg.querySelector('[data-kk-digi-modal-ack]').checked = false;
      dlg.querySelector('[data-kk-digi-ok]').disabled = true;
      dlg.showModal();
      KK.track('kk_digital_modal', { action: 'open' });
    }, true);
  }

  /* ---------- J-84: Teeinblue kiegészítők biztonságos törlése a kosárban (2026-10-19) ----------
     A Teeinblue a kollázs sorában (_tib_addon_variant: „variáns:db|…”) tartja nyilván a kiegészítőit, a
     kiegészítő sorok a _tib_customization_id-vel kötődnek a kollázs _customization_id-jéhez. A Minimog
     sorszám alapján töröl; ha csak a kiegészítő sort vette ki, a Teeinblue a következő kosárbetöltéskor
     visszatette, a beszúrás elcsúsztatta a sorszámokat, és a következő törlés rossz sort (akár a kollázst,
     vele az összes kiegészítőt) vitte. Javítás (vanilla fájl nélkül): a törlést átvesszük és KULCS alapján
     végezzük; kiegészítőnél a kollázs listájából is kivesszük, kollázsnál a saját kiegészítői is mennek;
     a kiegészítő soron nincs darabszám-állító; ha a kosár a háttérben változott, a nézet frissül. */
  const TIB_LIST = '_tib_addon_variant', TIB_MAIN = '_customization_id', TIB_ADDON = '_tib_customization_id';
  const tibAddon = (i) => !!(i && i.properties && i.properties[TIB_ADDON]);
  const tibMainId = (i) => (i && i.properties && i.properties[TIB_MAIN]) || '';
  const tibListDrop = (val, vid) => String(val || '').split('|').filter((x) => x && Number(x.split(':')[0]) !== vid).join('|');
  const JSON_H = { 'Content-Type': 'application/json', Accept: 'application/json' };
  function initTibCart() {
    const rowsOf = (root) => [...root.querySelectorAll('[data-cart-item][data-index]')];
    const rowVariant = (row) => { const a = row && row.querySelector('a[href*="variant="]'); const m = a && a.getAttribute('href').match(/variant=(\d+)/); return m ? Number(m[1]) : 0; };
    // A sor valódi kosárbeli helye (1-től) az id-ból (MinimogCart-Item-N, N = item.index + 1); a megjelenítési
    // sorrend a kk-cart-order szerint eltérhet a kosár sorrendjétől (fő termék elöl, kiegészítők utána).
    const rowLine = (row) => { const m = row && (row.id || '').match(/-Item-(\d+)$/); return m ? Number(m[1]) : 0; };
    // Friss kosár; az egymás után 700 ms-on belül érkező kéréseket összevonjuk (kevesebb kosár-lekérés).
    let fp = null, ft = 0;
    const fresh = (force) => {
      if (!force && fp && Date.now() - ft < 700) return fp;
      ft = Date.now();
      fp = fetch('/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' }).then((r) => { if (!r.ok) throw new Error('cart ' + r.status); return r.json(); });
      return fp;
    };
    let busy = false;
    const remove = async (btn) => {
      if (busy) return; busy = true;
      const row = btn.parentElement && btn.parentElement.closest('[data-cart-item]');
      if (row) row.classList.add('kk-row-busy');
      try {
        const idx = rowLine(row) || Number(btn.dataset.index) || 0; const vid = rowVariant(row);
        const cart = await fresh(true); const items = cart.items || [];
        let t = items[idx - 1];
        if (!t || (vid && t.variant_id !== vid)) t = items.find((i) => i.variant_id === vid) || null;
        if (!t) return;
        const updates = {};
        if (tibAddon(t)) {
          const cid = t.properties[TIB_ADDON];
          const main = items.find((i) => tibMainId(i) === cid);
          if (main && main.properties[TIB_LIST]) {
            const props = Object.assign({}, main.properties, { [TIB_LIST]: tibListDrop(main.properties[TIB_LIST], t.variant_id) });
            await fetch('/cart/change.js', { method: 'POST', headers: JSON_H, body: JSON.stringify({ id: main.key, quantity: main.quantity, properties: props }) });
          }
          updates[t.key] = 0;
          KK.track('kk_addon_remove', { variant: t.variant_id });
        } else {
          updates[t.key] = 0;
          const cid = tibMainId(t);
          if (cid) items.filter((i) => tibAddon(i) && i.properties[TIB_ADDON] === cid).forEach((a) => { updates[a.key] = 0; });
        }
        await fetch('/cart/update.js', { method: 'POST', headers: JSON_H, body: JSON.stringify({ updates }) });
      } catch (e) { console.warn('[KK] kosár törlés', e); }
      finally { busy = false; KK.refreshCart(); }
    };
    window.addEventListener('click', (e) => {
      const btn = e.target && e.target.closest && e.target.closest('m-cart-remove-button');
      if (!btn) return;
      e.preventDefault(); e.stopImmediatePropagation();
      remove(btn);
    }, true);
    // Kiegészítő sorok jelölése; ha a nézet és a kosár eltér (pl. a Teeinblue a háttérben takarított), frissítés.
    // A sorokat az id-ban lévő valódi kosárhely alapján párosítjuk a kosár tételeivel (a DOM-sorrend a kk-cart-order miatt eltér),
    // a változat-azonosítóval ellenőrizve. Csak akkor kérdezünk, ha a kosársorok listája változott.
    let lastFix = 0, fixes = 0, lastSig = '';
    const mark = async (force) => {
      const roots = [...document.querySelectorAll('m-cart, m-cart-drawer')].filter((r) => rowsOf(r).length);
      if (!roots.length) return;
      const sig = roots.map((r) => rowsOf(r).map(rowVariant).join(',')).join('/');
      if (!force && sig === lastSig) return;
      let cart; try { cart = await fresh(); } catch (e) { return; }
      lastSig = sig;
      const items = cart.items || [];
      roots.forEach((root) => {
        const rows = rowsOf(root);
        const at = (row) => items[rowLine(row) - 1];
        const same = rows.length === items.length && rows.every((row) => { const it = at(row); return !!it && rowVariant(row) === it.variant_id; });
        if (!same) { if (fixes < 2 && Date.now() - lastFix > 4000) { lastFix = Date.now(); fixes++; KK.refreshCart(); } return; } // legfeljebb kétszer oldalanként
        rows.forEach((row) => {
          const it = at(row);
          const addon = tibAddon(it);
          row.classList.toggle('kk-tib-addon', addon);
          if (addon && !row.querySelector('.kk-tib-note')) {
            const main = items.find((x) => tibMainId(x) === it.properties[TIB_ADDON]);
            const host = row.querySelector('.m-cart-drawer-item__variant, ul[data-cart-item-details], .m-cart-item__info, .m-cart-item__content');
            if (main && host) { const n = document.createElement(host.tagName === 'UL' ? 'li' : 'p'); n.className = 'kk-tib-note'; n.textContent = 'Kiegészítő ehhez: ' + main.product_title; host.appendChild(n); }
          }
        });
      });
    };
    mark();
    document.addEventListener('cart:refresh', () => setTimeout(() => mark(true), 900));
    // Csak a kosár elemeit figyeljük (nem az egész oldalt), hogy ne kérdezzük feleslegesen a kosarat.
    const mo = new MutationObserver(() => { clearTimeout(mark.t); mark.t = setTimeout(mark, 250); });
    document.querySelectorAll('m-cart, m-cart-drawer').forEach((el) => mo.observe(el, { childList: true, subtree: true }));
    setTimeout(() => mark(true), 3500); // a Teeinblue betöltés utáni takarítása után (egyszeri ellenőrzés)
  }

  /* ---------- J-82: „Csevegés” gomb a Shopify Inbox ablakot nyitja (2026-10-19) ----------
     A <shopify-chat> elem show() metódusával; tartalék: a shadow DOM-beli button.activator. Ha egyik sem
     érhető el, a kártya nem csinál semmit (a jobb alsó csevegő ikon továbbra is működik). */
  function initOpenChat() {
    const find = (root) => {
      if (!root) return null;
      for (const e of root.querySelectorAll('*')) {
        if (e.tagName === 'BUTTON' && e.classList.contains('activator')) return e;
        if (e.shadowRoot) { const r = find(e.shadowRoot); if (r) return r; }
      }
      return null;
    };
    document.addEventListener('click', (e) => {
      const t = e.target && e.target.closest && e.target.closest('[data-kk-open-chat]');
      if (!t) return;
      e.preventDefault();
      const host = document.querySelector('shopify-chat');
      if (!host) return;
      // Az Inbox nyilvános metódusa; a gomb programozott kattintását (isTrusted) figyelmen kívül hagyja.
      if (typeof host.show === 'function') { try { host.show(); KK.track('kk_open_chat', { from: 'kapcsolat' }); return; } catch (err) { /* tartalék lent */ } }
      const btn = find(host.shadowRoot);
      if (btn) { btn.click(); KK.track('kk_open_chat', { from: 'kapcsolat' }); }
    });
  }

  /* ---------- J-77: digitális fájl, utolsó megerősítés a pénztár előtt (2026-10-19) ----------
     Vésztartalék: ha a kosárban digitális tétel van, a pénztár (kosárfiók, kosároldal) és a gyorsfizetés
     előtt egy rövid ablak még egyszer kimondja, hogy postán nem küldünk semmit. Egy kattintás,
     naplózva (DIGI_ATTR, forrás: „pénztár előtt”). Egy kosárállapotra egyszer jelenik meg; ha a vásárló
     a kosárban a jelölőt pipálta be, nem kérdez újra. „Inkább keretes képet kérek”: a termékoldalra visz. */
  function initDigiFinal() {
    const SKEY = 'kk_digi_final';
    let mem = '';
    const sig = () => (KK.digiLines || []).map((l) => l.key).sort().join(',');
    const getDone = () => { try { return sessionStorage.getItem(SKEY) || mem; } catch (e) { return mem; } };
    const setDone = (v) => { mem = v; try { sessionStorage.setItem(SKEY, v); } catch (e) {} };
    KK.digiFinalNeeded = () => !!(KK.digiLines && KK.digiLines.length) && getDone() !== sig();
    KK.digiFinalDone = () => { setDone(sig()); document.dispatchEvent(new CustomEvent('kk:digi-state')); };
    let last = null;
    KK.digiFinalSync = () => { const n = KK.digiFinalNeeded(); if (n !== last) { last = n; document.dispatchEvent(new CustomEvent('kk:digi-state')); } };
    let dlg = null, pending = null;
    const esc = (t) => String(t || '').replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
    const finish = async (v, t) => {
      const lines = KK.digiLines || [];
      if (v === 'ok') {
        KK.track('kk_digital_final', { action: 'accept' });
        await KK.digiLog('pénztár előtt', [...new Set(lines.map((l) => l.handle))].join(', '));
        KK.digiFinalDone();
        if (t) t.click();
      } else if (v === 'framed') {
        KK.track('kk_digital_final', { action: 'framed' });
        if (lines[0] && lines[0].url) location.href = lines[0].url;
      } else KK.track('kk_digital_final', { action: 'cancel' });
    };
    const build = () => {
      dlg = document.createElement('dialog');
      dlg.className = 'kk-digi-modal kk-digi-final';
      dlg.setAttribute('aria-labelledby', 'kk-digi-final-title');
      document.body.appendChild(dlg);
      dlg.addEventListener('click', (e) => { if (e.target === dlg) dlg.close('cancel'); });
      dlg.addEventListener('close', () => { const t = pending; pending = null; finish(dlg.returnValue, t); });
    };
    KK.digiFinalOpen = (trigger) => {
      if (!dlg) build();
      const lines = KK.digiLines || [];
      const names = lines.map((l) => `<li><strong>${esc(l.title)}</strong>: digitális fájl</li>`).join('');
      dlg.innerHTML = `<form method="dialog" class="kk-digi-modal__box">
        <button type="submit" value="cancel" class="kk-digi-modal__x" aria-label="Bezárás">&times;</button>
        <p class="kk-digi-modal__eyebrow"><span>Utolsó ellenőrzés</span></p>
        <h2 id="kk-digi-final-title" class="kk-digi-modal__title">Digitális fájl van a kosaradban</h2>
        <ul class="kk-digi-modal__list">${names}
          <li><strong>Nem kapsz képkeretet és nyomtatott képet,</strong> postán nem küldünk semmit.</li>
          <li>A kész képet <strong>PNG fájlként e-mailben</strong> kapod meg.</li>
        </ul>
        <div class="kk-digi-modal__actions">
          <button type="submit" value="ok" class="kk-digi-modal__ok" autofocus>Rendben, tovább a pénztárhoz</button>
          <button type="submit" value="framed" class="kk-digi-modal__alt">Inkább keretes képet kérek</button>
        </div>
      </form>`;
      pending = trigger; dlg.returnValue = '';
      if (typeof dlg.showModal === 'function') { dlg.showModal(); KK.track('kk_digital_final', { action: 'open' }); return; }
      // Nagyon régi böngésző: natív megerősítés.
      if (window.confirm('Digitális fájl van a kosaradban: postán nem küldünk semmit, a képet e-mailben kapod meg. Tovább a pénztárhoz?')) { pending = null; finish('ok', trigger); }
    };
    window.addEventListener('click', (e) => {
      if (document.documentElement.classList.contains('kk-digi-pending')) return; // ott a kosár jelölője kapu
      const t = e.target && e.target.closest && e.target.closest('button[name="checkout"], input[name="checkout"], a[href$="/checkout"]');
      if (!t || !KK.digiFinalNeeded()) return;
      e.preventDefault(); e.stopImmediatePropagation();
      KK.digiFinalOpen(t);
    }, true);
  }

  /* ---------- J-68: méretsegítő és 13x18-as megerősítés számos kollázsnál (2026-10-19) ----------
     A méretválasztó alatt méretenként: hová ideális, felár a legkisebbhez képest, felület-szorzó.
     Számos kollázsnál 13x18-as (kis asztali) méretnél kosárba tételkor felugró ablak: váltás A4-re/A3-ra
     vagy megerősítés; a megerősítés rendelés-attribútumba kerül (SMALL_ATTR). Digitálisnál egyik sem jelenik meg. */
  const SMALL_ATTR = 'Kis méret (13x18) megerősítve';
  const SIZE_INFO = {
    s: { label: '13x18', area: 234, use: 'Kis asztali méret: polcra, íróasztalra, éjjeliszekrényre.' },
    m: { label: 'A4 (21x30)', area: 630, use: 'Falra vagy komódra. A legtöbben ezt választják.' },
    l: { label: 'A3 (30x40)', area: 1200, use: 'Nagy fali kép nappaliba, a fotók messziről is jól látszanak.' }
  };
  const sizeKey = (v) => { const t = String(v || '').replace(/\s/g, '').toLowerCase(); return /13x18|18x13/.test(t) ? 's' : /21x30|30x21|^a4/.test(t) ? 'm' : /30x40|40x30|^a3/.test(t) ? 'l' : null; };
  KK.attrLog = async (key, src, handle, ver) => {
    let prev = '';
    try { const c = await KK.cart(true); prev = (c.attributes && c.attributes[key]) || ''; } catch (e) {}
    const val = ((prev ? prev + ' ; ' : '') + [bpStamp(), src, handle, ver].filter(Boolean).join(' | ')).slice(-900);
    try { await fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ attributes: { [key]: val } }) }); } catch (e) {}
  };

  function initSizeGuide() {
    const vars = KK.variants(); if (!vars.length) return;
    const names = KK.optionNames();
    const sizeIdx = names.findIndex((x) => /m[ée]ret/i.test(x));
    if (sizeIdx < 0) return;
    const handle = decodeURIComponent((location.pathname.match(/\/products\/([^/?#]+)/) || [])[1] || '');
    const isNumber = /szamos/.test(handle);
    const kind = () => (KK.fmtKind ? KK.fmtKind() : 'other');
    // A Teeinblue terméktípus-választója (Elérhető termékek) adja az első opció valódi értékét.
    const curOpts = () => {
      const sel = KK.selectedOptions().slice();
      const ap = (KK.apText ? KK.apText() : '').trim();
      if (ap) { const hit = [...new Set(vars.map((v) => v.o[0]))].find((x) => x.trim() === ap); if (hit) sel[0] = hit; }
      return sel;
    };
    const group = () => (teeGroups().find((g) => g.idx === sizeIdx) || {}).el || null;
    const radios = () => { const g = group(); return g ? [...g.querySelectorAll('input[type="radio"]')] : []; };
    const selectedSize = () => { const s = curOpts()[sizeIdx]; if (s) return s; const r = radios().find((x) => x.checked) || (group() && group().querySelector('.tee-radio.active input')); return r ? r.value : null; };
    const priceFor = (val) => { const sel = curOpts(); const v = vars.find((x) => x.o[sizeIdx] === val && x.o.every((o, i) => i === sizeIdx || sel[i] == null || o === sel[i])); return v ? v.p : null; };
    const pickSize = (val) => {
      const r = radios().find((x) => x.value === val); if (!r) return false;
      const w = r.closest('.tee-radio'); ((w && w.querySelector('label')) || r).click();
      return true;
    };
    const fmtX = (n) => (Math.round(n * 10) / 10).toString().replace('.', ',');

    // 1) Méretsegítő
    const box = document.createElement('div');
    box.className = 'kk-size-guide'; box.hidden = true;
    box.addEventListener('click', (e) => { const li = e.target.closest('[data-kk-size]'); if (li && pickSize(li.dataset.kkSize)) { KK.track('kk_size_guide_pick', { size: li.dataset.kkSize }); setTimeout(paint, 400); } });
    const paint = () => {
      const g = group();
      const vals = radios().map((r) => r.value);
      const rows = vals.map((v) => ({ v, k: sizeKey(v), p: priceFor(v) })).filter((r) => r.k && r.p != null);
      if (!g || rows.length < 2 || kind() === 'digital') { box.hidden = true; return; }
      if (box.previousElementSibling !== g) g.after(box);
      const base = rows.reduce((a, b) => (SIZE_INFO[a.k].area <= SIZE_INFO[b.k].area ? a : b));
      const cur = selectedSize();
      box.innerHTML = `<p class="kk-size-guide__title">Melyik méretet válaszd?</p><ul class="kk-size-guide__list">${rows.map((r) => {
        const info = SIZE_INFO[r.k]; const d = r.p - base.p; const x = info.area / SIZE_INFO[base.k].area;
        const extra = r === base ? 'alapár' : `${d > 0 ? '+' + KK.money(d) : KK.money(r.p)}, ${fmtX(x)}× akkora kép`;
        return `<li data-kk-size="${r.v.replace(/"/g, '&quot;')}" class="${r.v === cur ? 'is-active' : ''}" role="button" tabindex="0"><span class="kk-size-guide__name">${info.label}</span><span class="kk-size-guide__use">${info.use}</span><span class="kk-size-guide__price">${extra}</span></li>`;
      }).join('')}</ul>`;
      box.hidden = false;
    };
    box.addEventListener('keydown', (e) => { if ((e.key === 'Enter' || e.key === ' ') && e.target.matches('[data-kk-size]')) { e.preventDefault(); e.target.click(); } });
    onVariant(() => setTimeout(paint, 80));
    document.addEventListener('click', (e) => { if (e.target && e.target.closest && e.target.closest('.tee-available-products, .tee-variants')) setTimeout(paint, 400); }, true);
    [400, 1200, 3000].forEach((ms) => setTimeout(paint, ms));

    // 2) Számos kollázs, 13x18: megerősítés kosárba tételkor
    if (!isNumber) return;
    let confirmed = false, dlg = null, pendingBtn = null;
    const build = () => {
      dlg = document.createElement('dialog');
      dlg.className = 'kk-digi-modal kk-size-modal'; dlg.setAttribute('aria-labelledby', 'kk-size-title');
      document.body.appendChild(dlg);
      dlg.addEventListener('click', (e) => { if (e.target === dlg) dlg.close('cancel'); });
      dlg.addEventListener('close', async () => {
        const v = dlg.returnValue || ''; const btn = pendingBtn; pendingBtn = null;
        if (v === 'small') {
          confirmed = true; KK.track('kk_small_size_modal', { action: 'keep' });
          await KK.attrLog(SMALL_ATTR, 'termékoldal', handle, 'szöveg v1 (2026-10-19)');
          if (btn) btn.click();
        } else if (v.startsWith('to:')) {
          const val = v.slice(3);
          if (pickSize(val)) { KK.track('kk_small_size_modal', { action: 'switch', to: val }); setTimeout(() => { paint(); const g = group(); if (g) g.scrollIntoView({ behavior: reduceMotion() ? 'auto' : 'smooth', block: 'center' }); }, 400); }
        } else KK.track('kk_small_size_modal', { action: 'cancel' });
      });
    };
    const ATC = '.tee-btn--atc, form[action*="/cart/add"] button[name="add"], form[action*="/cart/add"] [type="submit"]';
    window.addEventListener('click', (e) => {
      const btn = e.target && e.target.closest && e.target.closest(ATC);
      if (!btn || confirmed || kind() === 'digital') return;
      const cur = selectedSize();
      if (sizeKey(cur) !== 's') return;
      const curP = priceFor(cur);
      const ups = radios().map((r) => r.value).filter((v) => sizeKey(v) === 'm' || sizeKey(v) === 'l').map((v) => ({ v, k: sizeKey(v), p: priceFor(v) })).filter((x) => x.p != null && curP != null);
      if (!ups.length) return;
      e.preventDefault(); e.stopImmediatePropagation();
      if (!dlg) build();
      if (typeof dlg.showModal !== 'function') {
        if (window.confirm('Biztosan a kis, 13x18-as asztali méretet kéred? Falra legalább A4 (21x30) méretet javaslunk.')) { confirmed = true; KK.attrLog(SMALL_ATTR, 'termékoldal', handle, 'szöveg v1 (2026-10-19)').then(() => btn.click()); }
        return;
      }
      const ic = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M12 11v6M12 7.5h.01"/></svg>';
      dlg.innerHTML = `<form method="dialog" class="kk-digi-modal__box">
        <button type="submit" value="cancel" class="kk-digi-modal__x" aria-label="Bezárás">&times;</button>
        <p class="kk-digi-modal__eyebrow">${ic}<span>Egy gyors kérdés</span></p>
        <h2 id="kk-size-title" class="kk-digi-modal__title">Biztosan a kis, 13x18-as asztali méretet kéred?</h2>
        <p class="kk-size-modal__lead">A 13x18 cm-es kép kis asztali méret, a számban lévő fotók aprók lesznek rajta. Falra legalább az A4-es (21x30) méretet javasoljuk.</p>
        <div class="kk-digi-modal__actions kk-size-modal__actions">
          ${ups.map((u, i) => `<button type="submit" value="to:${u.v.replace(/"/g, '&quot;')}" class="${i === 0 ? 'kk-digi-modal__ok' : 'kk-digi-modal__alt'}"${i === 0 ? ' autofocus' : ''}>${u.k === 'm' ? 'A4-re váltok (21x30)' : 'A3-ra váltok (30x40)'}: +${KK.money(u.p - curP)}</button>`).join('')}
          <button type="submit" value="small" class="kk-size-modal__keep">Igen, a kis 13x18-as méretet kérem</button>
        </div>
      </form>`;
      pendingBtn = btn; dlg.returnValue = '';
      dlg.showModal();
      KK.track('kk_small_size_modal', { action: 'open' });
    }, true);
  }

  /* ---------- J-70: váltakozó vélemény a termékcím alatt ----------
     Legfeljebb 6 vélemény, 6 másodpercenként vált; egérrel fölé állva vagy fókuszban megáll.
     Mozgáscsökkentésnél nincs automatikus váltás (csak az első látszik). */
  /* ---------- J-76: soha nem ajánlott termékek (2026-10-19) ----------
     A Kiegészítők és a karbon-támogatás terméket semmilyen ajánlósor nem mutatja
     („Ezek is tetszhetnek”, kiegészítő ajánló blokk). Vanilla fájl érintése nélkül:
     a Minimog betöltése után kiveszi a kártyát, és frissíti a slidert. */
  const NO_RECO = ['tovabbi-kiegeszitok', 'support-for-groundbreaking-carbon-removal-technologies', 'mosoly-plusz'];
  function initNoReco(el) {
    const handleOf = (a) => ((a.getAttribute('href') || '').split('/products/')[1] || '').split(/[?#/]/)[0];
    const clean = () => {
      let n = 0;
      el.querySelectorAll('.m-product-card').forEach((card) => {
        const a = card.querySelector('a[href*="/products/"]');
        if (!a || !NO_RECO.includes(handleOf(a))) return;
        (card.closest('.swiper-slide, .m\\:column') || card).remove(); n++;
      });
      if (n && el.swiper) { try { el.swiper.update(); } catch (e) { /* nincs slider */ } }
    };
    clean();
    new MutationObserver(clean).observe(el, { childList: true });
  }

  function initPdpRev(box) {
    const items = [...box.querySelectorAll('.kk-pdp-rev__item')].slice(0, 6);
    box.querySelectorAll('.kk-pdp-rev__item').forEach((li, i) => { if (i >= 6) li.remove(); });
    if (!items.length) return;
    const list = box.querySelector('.kk-pdp-rev__list');
    let i = 0, paused = false, inView = false;
    /* A doboz magassága mindig az aktuális véleményhez igazodik (rövid véleménynél nincs üres hely) */
    const fit = () => { list.style.height = items[i].offsetHeight + 'px'; };
    items.forEach((li, k) => { li.classList.toggle('is-on', k === 0); li.setAttribute('aria-hidden', k === 0 ? 'false' : 'true'); });
    fit();
    window.addEventListener('resize', fit, { passive: true });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);
    if (items.length < 2 || reduceMotion()) return;
    box.addEventListener('mouseenter', () => { paused = true; });
    box.addEventListener('mouseleave', () => { paused = false; });
    box.addEventListener('focusin', () => { paused = true; });
    box.addEventListener('focusout', () => { paused = false; });
    /* Csak akkor vált, ha a doboz látszik: így a magasságváltás sosem tolja el azt, amit a vásárló lejjebb éppen olvas vagy kitölt */
    if ('IntersectionObserver' in window) new IntersectionObserver((es) => { inView = es[0].isIntersecting; }, { threshold: 0.6 }).observe(box);
    else inView = true;
    setInterval(() => {
      if (paused || !inView || document.hidden) return;
      items[i].classList.remove('is-on'); items[i].setAttribute('aria-hidden', 'true');
      i = (i + 1) % items.length;
      items[i].classList.add('is-on'); items[i].setAttribute('aria-hidden', 'false');
      fit();
    }, 6000);
  }

  /* ---------- Számos termék: ?szam=42 előtölti a Teeinblue számmezőit (2026-10-18) ----------
     A számmezők azok a Teeinblue-mezők, amelyek fejlécében „szám” szerepel, és a választható
     elemek felirata pontosan 0-9 (0-99: bal és jobb, 0-9: egy, évszámos: négy mező).
     Csak akkor állít, ha a számjegyek száma egyezik a mezők számával; a vásárló utána szabadon módosíthat. */
  function initNumberPrefill() {
    const raw = new URLSearchParams(location.search).get('szam');
    if (!raw || !/^\d{1,4}$/.test(raw)) return;
    const digits = String(parseInt(raw, 10)).split('');
    let tries = 0, done = false;
    const run = () => {
      if (done) return true;
      const fields = [...document.querySelectorAll('#tee-artwork-form .tee-field')].filter((f) => {
        const h = (f.querySelector('.tee-field__heading') || {}).textContent || '';
        const t = [...f.querySelectorAll('label[data-title]')].map((l) => l.dataset.title);
        return /sz[aá]m/i.test(h) && t.length === 10 && t.every((x, i) => x === String(i));
      });
      if (!fields.length) return false;
      // A-57: rövidebb szám bal oldali nullával (7 a 0-99 terméken: 0 és 7).
      const dg = digits.length < fields.length ? Array(fields.length - digits.length).fill('0').concat(digits) : digits;
      if (fields.length !== dg.length) { done = true; return true; }
      // A kattintás fókuszt és görgetést okozna: a pozíciót megtartjuk, a vásárló az oldal tetején marad.
      const y = window.scrollY;
      fields.forEach((f, i) => { const l = f.querySelector('label[data-title="' + dg[i] + '"]'); const inp = l && document.getElementById(l.htmlFor); if (l && !(inp && inp.checked)) l.click(); });
      if (document.activeElement && document.activeElement.closest && document.activeElement.closest('#tee-artwork-form')) document.activeElement.blur();
      let user = false; const stop = () => { user = true; };
      ['wheel', 'touchstart', 'keydown', 'pointerdown'].forEach((ev) => window.addEventListener(ev, stop, { once: true, passive: true }));
      const keep = (k) => { if (user) return; if (Math.abs(window.scrollY - y) > 2) window.scrollTo({ top: y, behavior: 'instant' }); if (k < 20) setTimeout(() => keep(k + 1), 100); };
      keep(0);
      done = true;
      KK.track('kk_number_prefill', { n: parseInt(raw, 10) });
      return true;
    };
    const tick = () => { if (run() || ++tries > 60) return; setTimeout(tick, 250); };
    tick();
  }

  /* A-04: a fejléc kereső-popupja Esc-re és a háttér érintésére is záródjon (mobilon is). */
  function initSearchClose() {
    document.addEventListener('keydown', (e) => {
      if (e.key !== 'Escape') return;
      const pop = document.querySelector('[data-search-popup]');
      if (!pop || getComputedStyle(pop).visibility === 'hidden') return;
      const btn = pop.querySelector('[data-close-search]');
      if (btn) btn.click();
    });
  }

  /* A-34, A-56: a vanilla mobil alsó sáv és a „vissza a tetejére” gomb angol aria-címkéi magyarul
     (a vanilla fájl módosítása nélkül, futásidőben). */
  function initA11yLabels() {
    const set = (el, label) => { if (el) el.setAttribute('aria-label', label); };
    document.querySelectorAll('.m-mobile-sticky-bar a[aria-label="product"]').forEach((a) => set(a, 'Főoldal'));
    document.querySelectorAll('.m-mobile-sticky-bar a[aria-label="collection"]').forEach((a) => set(a, 'Összes termék'));
    document.querySelectorAll('.m-mobile-sticky-bar a[aria-label="wishlist"]').forEach((a) => set(a, 'Kívánságlista'));
    document.querySelectorAll('.m-mobile-sticky-bar a[aria-label="account"]').forEach((a) => set(a, 'Fiókom'));
    document.querySelectorAll('.m-mobile-sticky-bar m-search-popup').forEach((m) => { m.setAttribute('role', 'button'); m.setAttribute('tabindex', '0'); set(m, 'Keresés'); });
    document.querySelectorAll('.m-mobile-sticky-bar a[href*="/cart"]').forEach((a) => { if (!/kos/i.test(a.getAttribute('aria-label') || '')) set(a, 'Kosár'); });
    set(document.getElementById('scroll-to-top-button'), 'Vissza az oldal tetejére');
  }

  /* A-53: egy hibás modul ne állítsa le a többit. */
  const run = (name, fn) => { try { fn(); } catch (e) { try { console.warn('[kk] ' + name, e); } catch (x) {} } };
  const each = (sel, fn) => document.querySelectorAll(sel).forEach((el) => run(sel, () => fn(el)));

  const boot = () => {
    run('numberPrefill', initNumberPrefill);
    each('[data-kk-delivery]', initDelivery);
    each('[data-kk-pdp-rev]', initPdpRev);
    each('product-recommendations, .main-product__block-complementary', initNoReco);
    each('[data-kk-frames]', initFrames);
    each('[data-kk-ship]', initShip);
    run('sizePrices', initSizePrices);
    if (document.querySelector('script[data-kk-variants]')) { run('missing', initMissing); run('teeEvents', initTeeEvents); run('stickyBar', initStickyBar); run('formatNotice', initFormatNotice); run('sizeGuide', initSizeGuide); }
    run('digiFinal', initDigiFinal);
    run('tibCart', initTibCart);
    if (document.querySelector('[data-kk-open-chat]')) run('openChat', initOpenChat);
    run('cartExtras', initCartExtras);
    run('cartTidy', initCartTidy);
    run('cartBar', initCartBar);
    run('agreeGuard', initAgreeGuard);
    run('landing', initLanding);
    each('[data-kk-ptabs]', initProductTabs);
    each('[data-kk-swipe]', initSwipe);
    each('[data-kk-hero-rotate]', initHeroRotate);
    each('[data-kk-float-rotate]', initFloatRotate);
    run('season', initSeason);
    run('vacation', initVacation);
    run('cookielink', initCookieLink);
    run('atcguard', initAtcGuard);
    run('searchClose', initSearchClose);
    run('a11yLabels', initA11yLabels);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
